
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kKODE", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $5b5d947ab1fa491a$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1PKWZ = parcelRequire("1PKWZ");

var $cGziR = parcelRequire("cGziR");
const $5b5d947ab1fa491a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $gwFzn.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $cGziR.default)(...params));
        event.fire((0, $1PKWZ.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("1PKWZ", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $6678419bc4dceb3a$export$3f072f06b90c3985);
const $6678419bc4dceb3a$export$3f072f06b90c3985 = 'media';

});

parcelRegister("cGziR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4575fec4bf8df71a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $4575fec4bf8df71a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4575fec4bf8df71a$export$2e2bcd8739ae039 = $4575fec4bf8df71a$var$createEventPayload;

});


parcelRegister("bIll3", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $fe01df8db47f84d1$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $fe01df8db47f84d1$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $fe01df8db47f84d1$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $fe01df8db47f84d1$export$4084c0df4a03a6af);

var $9801n = parcelRequire("9801n");
var $iqaft = parcelRequire("iqaft");
const $fe01df8db47f84d1$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
};
const $fe01df8db47f84d1$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9801n.ConcurrentExperience)('smart-link-rendered', $fe01df8db47f84d1$var$renderExperience),
    'smart-link-authenticated': new (0, $9801n.ConcurrentExperience)('smart-link-authenticated', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9801n.ConcurrentExperience)('smart-link-action-invocation', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9801n.ConcurrentExperience)('smart-link-ai-summary', $fe01df8db47f84d1$var$aiExperience)
};
const $fe01df8db47f84d1$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $fe01df8db47f84d1$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("ivUmx", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $71dfdac77e49ff43$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $71dfdac77e49ff43$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $71dfdac77e49ff43$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $71dfdac77e49ff43$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $71dfdac77e49ff43$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $71dfdac77e49ff43$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $71dfdac77e49ff43$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $71dfdac77e49ff43$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $71dfdac77e49ff43$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $71dfdac77e49ff43$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $71dfdac77e49ff43$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $71dfdac77e49ff43$export$6a4545d6b336c401);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4wH3g = parcelRequire("4wH3g");

var $dh538 = parcelRequire("dh538");

var $j6S25 = parcelRequire("j6S25");

var $5TXU5 = parcelRequire("5TXU5");

var $f6wMd = parcelRequire("f6wMd");
const $71dfdac77e49ff43$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($71dfdac77e49ff43$export$e6c5ffa684aac4d7() || $71dfdac77e49ff43$export$d8de0cd37d316fdf(evt) || $71dfdac77e49ff43$export$5b1771037ab7c451(evt));
const $71dfdac77e49ff43$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $71dfdac77e49ff43$export$d8de0cd37d316fdf = (event)=>{
    return (0, $dh538.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $71dfdac77e49ff43$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $71dfdac77e49ff43$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $71dfdac77e49ff43$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "Zuvzb",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $71dfdac77e49ff43$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $71dfdac77e49ff43$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $71dfdac77e49ff43$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5TXU5.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9SMct")))
        },
        [(0, $5TXU5.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("7r4Rz")))
        },
        [(0, $5TXU5.IconType).Audio]: {
            default: ()=>(parcelRequire("GoiPd"))
        },
        [(0, $5TXU5.IconType).Code]: {
            default: ()=>(parcelRequire("6BRgI"))
        },
        [(0, $5TXU5.IconType).File]: {
            default: ()=>(parcelRequire("eShon"))
        },
        [(0, $5TXU5.IconType).Folder]: {
            default: ()=>(parcelRequire("cLezH"))
        },
        [(0, $5TXU5.IconType).Generic]: {
            default: ()=>(parcelRequire("eShon"))
        },
        [(0, $5TXU5.IconType).Image]: {
            default: ()=>(parcelRequire("8iG6e"))
        },
        [(0, $5TXU5.IconType).Presentation]: {
            default: ()=>(parcelRequire("37vJP"))
        },
        [(0, $5TXU5.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("4bCDb"))
        },
        [(0, $5TXU5.IconType).Video]: {
            default: ()=>(parcelRequire("fO7jW"))
        },
        [(0, $5TXU5.IconType).Project]: {
            default: ()=>(parcelRequire("9mf2A"))
        },
        [(0, $5TXU5.IconType).Template]: {
            default: ()=>(parcelRequire("6zdW4"))
        },
        [(0, $5TXU5.IconType).Forbidden]: {
            default: ()=>(parcelRequire("9QdIO"))
        },
        [(0, $5TXU5.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("8Q3VW")))
        },
        [(0, $5TXU5.IconType).Archive]: {
            default: ()=>(parcelRequire("icf9z")),
            large: ()=>(parcelRequire("a86hb"))
        },
        [(0, $5TXU5.IconType).Executable]: {
            default: ()=>(parcelRequire("kscP5")),
            large: ()=>(parcelRequire("hPBqs"))
        },
        [(0, $5TXU5.IconType).GIF]: {
            default: ()=>(parcelRequire("k5T7h")),
            large: ()=>(parcelRequire("hd3xq"))
        },
        [(0, $5TXU5.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("1qYnK")),
            large: ()=>(parcelRequire("3grNr"))
        },
        [(0, $5TXU5.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("f2prL")),
            large: ()=>(parcelRequire("kkK3B"))
        },
        [(0, $5TXU5.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("cfQQr")),
            large: ()=>(parcelRequire("ar2MQ"))
        },
        [(0, $5TXU5.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("25gta")),
            large: ()=>(parcelRequire("b4d77"))
        },
        [(0, $5TXU5.IconType).MSExcel]: {
            default: ()=>(parcelRequire("kEmyI")),
            large: ()=>(parcelRequire("gML09"))
        },
        [(0, $5TXU5.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("f8uMq")),
            large: ()=>(parcelRequire("3pfn4"))
        },
        [(0, $5TXU5.IconType).MSWord]: {
            default: ()=>(parcelRequire("dRwZ6")),
            large: ()=>(parcelRequire("ehMoK"))
        },
        [(0, $5TXU5.IconType).PDF]: {
            default: ()=>(parcelRequire("bb6Gy")),
            large: ()=>(parcelRequire("kc9hI"))
        },
        [(0, $5TXU5.IconType).Sketch]: {
            default: ()=>(parcelRequire("bYzU1")),
            large: ()=>(parcelRequire("9VPT7"))
        },
        // Bitbucket icons
        [(0, $5TXU5.IconType).Branch]: {
            default: ()=>(parcelRequire("d2cfy")),
            large: ()=>(parcelRequire("i75PE"))
        },
        [(0, $5TXU5.IconType).Commit]: {
            default: ()=>(parcelRequire("81TyL")),
            large: ()=>(parcelRequire("2Ozwh"))
        },
        [(0, $5TXU5.IconType).PullRequest]: {
            default: ()=>(parcelRequire("2gccM")),
            large: ()=>(parcelRequire("6GZ4c"))
        },
        [(0, $5TXU5.IconType).Repo]: {
            default: ()=>(parcelRequire("juN6W")),
            large: ()=>(parcelRequire("7juxi"))
        },
        // Jira icons
        [(0, $5TXU5.IconType).Bug]: {
            default: ()=>(parcelRequire("hzstf")),
            large: ()=>(parcelRequire("iakNa"))
        },
        [(0, $5TXU5.IconType).Change]: {
            default: ()=>(parcelRequire("1m9zI")),
            large: ()=>(parcelRequire("jvqx7"))
        },
        [(0, $5TXU5.IconType).Epic]: {
            default: ()=>(parcelRequire("hH3YO")),
            large: ()=>(parcelRequire("iOb23"))
        },
        [(0, $5TXU5.IconType).Incident]: {
            default: ()=>(parcelRequire("2zDj3")),
            large: ()=>(parcelRequire("n9DyQ"))
        },
        [(0, $5TXU5.IconType).Problem]: {
            default: ()=>(parcelRequire("4Cjsp")),
            large: ()=>(parcelRequire("bv42r"))
        },
        [(0, $5TXU5.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("itqQ6")),
            large: ()=>(parcelRequire("bkl6V"))
        },
        [(0, $5TXU5.IconType).Story]: {
            default: ()=>(parcelRequire("erjiS")),
            large: ()=>(parcelRequire("7G0y2"))
        },
        [(0, $5TXU5.IconType).SubTask]: {
            default: ()=>(parcelRequire("9RRKT")),
            large: ()=>(parcelRequire("iGsKW"))
        },
        [(0, $5TXU5.IconType).Task]: {
            default: ()=>(parcelRequire("4RtEN")),
            large: ()=>(parcelRequire("kMOBw"))
        },
        // Confluence icons
        [(0, $5TXU5.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("brDJd"))),
            large: ()=>Promise.resolve((parcelRequire("deok5")))
        },
        // Provider icons
        [(0, $5TXU5.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("7skR0"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5TXU5.IconType).Jira]: {
            default: ()=>Promise.resolve((parcelRequire("eO4W8"))).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5TXU5.IconType).Attachment]: {
            default: ()=>(parcelRequire("9S0Uv"))
        },
        [(0, $5TXU5.IconType).CheckItem]: {
            default: ()=>(parcelRequire("dvFpI"))
        },
        [(0, $5TXU5.IconType).Component]: {
            default: ()=>(parcelRequire("kqDAR"))
        },
        [(0, $5TXU5.IconType).Comment]: {
            default: ()=>(parcelRequire("1tPAM"))
        },
        [(0, $5TXU5.IconType).View]: {
            default: ()=>(parcelRequire("cSCYi"))
        },
        [(0, $5TXU5.IconType).React]: {
            default: ()=>(parcelRequire("lp57s"))
        },
        [(0, $5TXU5.IconType).Vote]: {
            default: ()=>(parcelRequire("2q5WZ"))
        },
        [(0, $5TXU5.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("gfVkp"))
        },
        [(0, $5TXU5.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("hgbfX"))
        },
        [(0, $5TXU5.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("d4dgh"))
        },
        [(0, $5TXU5.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("8gGKC"))
        },
        [(0, $5TXU5.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("eHEdz"))
        },
        [(0, $5TXU5.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("9B7dU"))
        },
        [(0, $5TXU5.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("dJ8xq"))
        },
        [(0, $5TXU5.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("8snbs"))
        },
        [(0, $5TXU5.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("h7AKi"))
        },
        [(0, $5TXU5.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("3FWbZ"))
        },
        [(0, $5TXU5.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("jjUMn"))
        },
        [(0, $5TXU5.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("8fzGq"))
        },
        [(0, $5TXU5.IconType).Subscriber]: {
            default: ()=>(parcelRequire("1JBYF"))
        },
        [(0, $5TXU5.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("4auN3"))
        }
    };
};
const $71dfdac77e49ff43$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $f6wMd.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $71dfdac77e49ff43$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $71dfdac77e49ff43$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $71dfdac77e49ff43$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $71dfdac77e49ff43$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $71dfdac77e49ff43$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $71dfdac77e49ff43$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $71dfdac77e49ff43$export$e772c8ff12451969(interval);
            return $71dfdac77e49ff43$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $71dfdac77e49ff43$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $71dfdac77e49ff43$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $71dfdac77e49ff43$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $j6S25.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $71dfdac77e49ff43$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5TXU5.SmartLinkSize).Large,
        (0, $5TXU5.SmartLinkSize).XLarge
    ].includes(size);
const $71dfdac77e49ff43$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("5TXU5", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $d747218f543c7aaa$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $d747218f543c7aaa$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $d747218f543c7aaa$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $d747218f543c7aaa$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $d747218f543c7aaa$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $d747218f543c7aaa$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $d747218f543c7aaa$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $d747218f543c7aaa$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $d747218f543c7aaa$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $d747218f543c7aaa$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $d747218f543c7aaa$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $d747218f543c7aaa$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $d747218f543c7aaa$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $d747218f543c7aaa$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $d747218f543c7aaa$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $d747218f543c7aaa$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $d747218f543c7aaa$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $d747218f543c7aaa$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $d747218f543c7aaa$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $d747218f543c7aaa$export$6ca4ef8b3dc2c804);
const $d747218f543c7aaa$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d747218f543c7aaa$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d747218f543c7aaa$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d747218f543c7aaa$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d747218f543c7aaa$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $d747218f543c7aaa$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $d747218f543c7aaa$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $d747218f543c7aaa$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $d747218f543c7aaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $d747218f543c7aaa$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $d747218f543c7aaa$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $d747218f543c7aaa$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $d747218f543c7aaa$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $d747218f543c7aaa$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $d747218f543c7aaa$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $d747218f543c7aaa$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $d747218f543c7aaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $d747218f543c7aaa$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $d747218f543c7aaa$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $d747218f543c7aaa$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("f6wMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8700f5e69c6738e7$export$2e2bcd8739ae039);

var $5TXU5 = parcelRequire("5TXU5");
const $8700f5e69c6738e7$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5TXU5.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5TXU5.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5TXU5.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5TXU5.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5TXU5.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5TXU5.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5TXU5.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5TXU5.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5TXU5.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5TXU5.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5TXU5.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5TXU5.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5TXU5.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5TXU5.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5TXU5.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5TXU5.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5TXU5.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5TXU5.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5TXU5.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5TXU5.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $8700f5e69c6738e7$export$2e2bcd8739ae039 = $8700f5e69c6738e7$var$extractFileFormatIcon;

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3c9171fc16956912$export$2e2bcd8739ae039);

var $5mB97 = parcelRequire("5mB97");

var $i9cac = parcelRequire("i9cac");

var $8jHAi = parcelRequire("8jHAi");

var $7CgcZ = parcelRequire("7CgcZ");
const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5mB97))), (0, (/*@__PURE__*/$parcel$interopDefault($i9cac)))));
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;

});
parcelRegister("7CgcZ", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $6846287c8ee6bf50$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $6846287c8ee6bf50$export$87c3646d0e299cfe);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $5TXU5 = parcelRequire("5TXU5");

var $ivUmx = parcelRequire("ivUmx");
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $7UHDa.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)(IconSmall, {
            ...props
        });
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
            appearance: appearance,
            icon: Icon,
            size: $6846287c8ee6bf50$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $7UHDa.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});


parcelRegister("7r4Rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a1b21c3b6fc75776$export$2e2bcd8739ae039);

var $hxQwS = parcelRequire("hxQwS");

var $bueVT = parcelRequire("bueVT");

var $7CgcZ = parcelRequire("7CgcZ");
const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $hxQwS.default), (0, $bueVT.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;

});

parcelRegister("GoiPd", function(module, exports) {

let $07f6c65ac323607e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $07f6c65ac323607e$var$load("jDjSj"),
    $07f6c65ac323607e$var$load("kO0mz")
]).then(()=>parcelRequire('kYM3c'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("6BRgI", function(module, exports) {

let $4cff84d0b713e073$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4cff84d0b713e073$var$load("3wmvj"),
    $4cff84d0b713e073$var$load("gQLjx")
]).then(()=>parcelRequire('3OcEi'));

});

parcelRegister("eShon", function(module, exports) {

let $ad43998f6bbd6497$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ad43998f6bbd6497$var$load("kDqHr").then(()=>parcelRequire('9JsQ8'));

});

parcelRegister("cLezH", function(module, exports) {

let $94a52e1040819846$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $94a52e1040819846$var$load("5i5pX").then(()=>parcelRequire('ltRMD'));

});

parcelRegister("8iG6e", function(module, exports) {

let $60b0a946982667e3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $60b0a946982667e3$var$load("8059b"),
    $60b0a946982667e3$var$load("eA5B3")
]).then(()=>parcelRequire('gcJKc'));

});

parcelRegister("37vJP", function(module, exports) {

let $245aa5180671209b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $245aa5180671209b$var$load("4HZlX").then(()=>parcelRequire('1w5AW'));

});

parcelRegister("4bCDb", function(module, exports) {

let $30c627ca69a75029$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $30c627ca69a75029$var$load("7jSfd").then(()=>parcelRequire('h45kr'));

});

parcelRegister("fO7jW", function(module, exports) {

let $b8213445d2d5f3a7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b8213445d2d5f3a7$var$load("hPalR"),
    $b8213445d2d5f3a7$var$load("7AsyI")
]).then(()=>parcelRequire('480Js'));

});

parcelRegister("9mf2A", function(module, exports) {

let $6d01d5e7662643cd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6d01d5e7662643cd$var$load("4x0L6").then(()=>parcelRequire('fXYLR'));

});

parcelRegister("6zdW4", function(module, exports) {

let $4c80d24362680ae6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4c80d24362680ae6$var$load("k6H7B").then(()=>parcelRequire('2YaGf'));

});

parcelRegister("9QdIO", function(module, exports) {

let $72a39d42f5713f86$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $72a39d42f5713f86$var$load("8LPnw").then(()=>parcelRequire('bRfUA'));

});

parcelRegister("icf9z", function(module, exports) {

let $d3f51a1f2a77808c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d3f51a1f2a77808c$var$load("2fk6g").then(()=>parcelRequire('dlbUV'));

});

parcelRegister("a86hb", function(module, exports) {

let $75ff85078c2ed1ab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75ff85078c2ed1ab$var$load("dil5i").then(()=>parcelRequire('fX9Sa'));

});

parcelRegister("kscP5", function(module, exports) {

let $ee405e887cc23ac5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ee405e887cc23ac5$var$load("huUvS").then(()=>parcelRequire('2ixko'));

});

parcelRegister("hPBqs", function(module, exports) {

let $cfb43b137b722cb1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cfb43b137b722cb1$var$load("P5iE2").then(()=>parcelRequire('4dLYc'));

});

parcelRegister("k5T7h", function(module, exports) {

let $ea0f074652d059fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ea0f074652d059fd$var$load("1oiJ6").then(()=>parcelRequire('d5BUD'));

});

parcelRegister("hd3xq", function(module, exports) {

let $c876652aec92aae5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c876652aec92aae5$var$load("42vdC").then(()=>parcelRequire('b4DX7'));

});

parcelRegister("1qYnK", function(module, exports) {

let $10b70ec32af8c31d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $10b70ec32af8c31d$var$load("lxiFd").then(()=>parcelRequire('4rkAw'));

});

parcelRegister("3grNr", function(module, exports) {

let $26086d81f65006fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $26086d81f65006fd$var$load("9Bu2S").then(()=>parcelRequire('5W6v1'));

});

parcelRegister("f2prL", function(module, exports) {

let $af2ac82573c25707$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af2ac82573c25707$var$load("eDqo1").then(()=>parcelRequire('jDMpf'));

});

parcelRegister("kkK3B", function(module, exports) {

let $ecd966e3c0f21332$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ecd966e3c0f21332$var$load("8pE8S").then(()=>parcelRequire('av4P2'));

});

parcelRegister("cfQQr", function(module, exports) {

let $024d6ad95162d834$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $024d6ad95162d834$var$load("6HBYC").then(()=>parcelRequire('l59oX'));

});

parcelRegister("ar2MQ", function(module, exports) {

let $798e9664dc7355d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $798e9664dc7355d0$var$load("ivQYH").then(()=>parcelRequire('giYeH'));

});

parcelRegister("25gta", function(module, exports) {

let $1848d2e79896f624$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1848d2e79896f624$var$load("bYxCZ").then(()=>parcelRequire('jOGxt'));

});

parcelRegister("b4d77", function(module, exports) {

let $80ea3d90d6644a01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80ea3d90d6644a01$var$load("7a9CL").then(()=>parcelRequire('eWLPt'));

});

parcelRegister("kEmyI", function(module, exports) {

let $f0890ac8d853fa59$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0890ac8d853fa59$var$load("eTBsW").then(()=>parcelRequire('d8Kpd'));

});

parcelRegister("gML09", function(module, exports) {

let $c3859685823f8ffc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3859685823f8ffc$var$load("8mzoy").then(()=>parcelRequire('gH8Rx'));

});

parcelRegister("f8uMq", function(module, exports) {

let $b04f7aaa98b02b1b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b04f7aaa98b02b1b$var$load("020xd").then(()=>parcelRequire('hY1Uy'));

});

parcelRegister("3pfn4", function(module, exports) {

let $27afa140cf6d4ad7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $27afa140cf6d4ad7$var$load("bjzRn").then(()=>parcelRequire('dfQbH'));

});

parcelRegister("dRwZ6", function(module, exports) {

let $a179cfa5888e8e00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a179cfa5888e8e00$var$load("ls0Um").then(()=>parcelRequire('90Icb'));

});

parcelRegister("ehMoK", function(module, exports) {

let $a6683214f49d09be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a6683214f49d09be$var$load("fYi1a").then(()=>parcelRequire('lkBga'));

});

parcelRegister("bb6Gy", function(module, exports) {

let $8235e85ddce5d7b2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8235e85ddce5d7b2$var$load("eVYW1").then(()=>parcelRequire('11LZV'));

});

parcelRegister("kc9hI", function(module, exports) {

let $eb3c21678f401c25$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb3c21678f401c25$var$load("fqrMn").then(()=>parcelRequire('lzyQK'));

});

parcelRegister("bYzU1", function(module, exports) {

let $8b8125d44d11cedd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8b8125d44d11cedd$var$load("f35QR").then(()=>parcelRequire('9W0IA'));

});

parcelRegister("9VPT7", function(module, exports) {

let $73b1afc933b7f23e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $73b1afc933b7f23e$var$load("hzK1f").then(()=>parcelRequire('9AnKp'));

});

parcelRegister("d2cfy", function(module, exports) {

let $97d4f6d74f698cb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $97d4f6d74f698cb6$var$load("7OtNC").then(()=>parcelRequire('iNt9O'));

});

parcelRegister("i75PE", function(module, exports) {

let $d2fd678c69626915$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d2fd678c69626915$var$load("4sSyn").then(()=>parcelRequire('lU7yV'));

});

parcelRegister("81TyL", function(module, exports) {

let $5d8983b4d6f8473e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5d8983b4d6f8473e$var$load("dzfxi").then(()=>parcelRequire('g3kRp'));

});

parcelRegister("2Ozwh", function(module, exports) {

let $20cbcdc464cd9c06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $20cbcdc464cd9c06$var$load("dnrR3").then(()=>parcelRequire('jB3l2'));

});

parcelRegister("2gccM", function(module, exports) {

let $1a568b18dc77ff69$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1a568b18dc77ff69$var$load("47wm8").then(()=>parcelRequire('48jO6'));

});

parcelRegister("6GZ4c", function(module, exports) {

let $4df608eb58a54996$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4df608eb58a54996$var$load("gxkp2").then(()=>parcelRequire('8EuWv'));

});

parcelRegister("juN6W", function(module, exports) {

let $e316ea0d41e672ac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e316ea0d41e672ac$var$load("cMkgU").then(()=>parcelRequire('gP2jG'));

});

parcelRegister("7juxi", function(module, exports) {

let $5531fe901225409d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5531fe901225409d$var$load("hiqrg").then(()=>parcelRequire('59qhj'));

});

parcelRegister("hzstf", function(module, exports) {

let $ccabca3a1732c203$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ccabca3a1732c203$var$load("f28kH").then(()=>parcelRequire('5pEhQ'));

});

parcelRegister("iakNa", function(module, exports) {

let $d3994a06c18d06c4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d3994a06c18d06c4$var$load("490Jr").then(()=>parcelRequire('go9q2'));

});

parcelRegister("1m9zI", function(module, exports) {

let $0fcf45ecfc58db96$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0fcf45ecfc58db96$var$load("j2OLf").then(()=>parcelRequire('gyMYQ'));

});

parcelRegister("jvqx7", function(module, exports) {

let $e3357e84d00cba08$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e3357e84d00cba08$var$load("ggkqU").then(()=>parcelRequire('2hyOi'));

});

parcelRegister("hH3YO", function(module, exports) {

let $ce198a271158b0dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ce198a271158b0dc$var$load("fKONs").then(()=>parcelRequire('g30aC'));

});

parcelRegister("iOb23", function(module, exports) {

let $db15743e48de60ec$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $db15743e48de60ec$var$load("65smn").then(()=>parcelRequire('7MtzJ'));

});

parcelRegister("2zDj3", function(module, exports) {

let $1dfd570eafce5431$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1dfd570eafce5431$var$load("3c6qD").then(()=>parcelRequire('ieNZ0'));

});

parcelRegister("n9DyQ", function(module, exports) {

let $04599fd21c7f9f9c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $04599fd21c7f9f9c$var$load("1fh7t").then(()=>parcelRequire('iyOJu'));

});

parcelRegister("4Cjsp", function(module, exports) {

let $35c9cdd00a8cb086$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $35c9cdd00a8cb086$var$load("b1gz4").then(()=>parcelRequire('736YY'));

});

parcelRegister("bv42r", function(module, exports) {

let $85f5b8e5270e490e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $85f5b8e5270e490e$var$load("4mLGd").then(()=>parcelRequire('75US5'));

});

parcelRegister("itqQ6", function(module, exports) {

let $d72fc130b1ed6f31$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d72fc130b1ed6f31$var$load("8Xuep").then(()=>parcelRequire('GLxTx'));

});

parcelRegister("bkl6V", function(module, exports) {

let $83f1f01bcbe5b129$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $83f1f01bcbe5b129$var$load("cMlHc").then(()=>parcelRequire('2v58P'));

});

parcelRegister("erjiS", function(module, exports) {

let $a8328f9261d933f4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a8328f9261d933f4$var$load("abVVB").then(()=>parcelRequire('hrqJ0'));

});

parcelRegister("7G0y2", function(module, exports) {

let $596ce17c30b45c92$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $596ce17c30b45c92$var$load("lSzlP").then(()=>parcelRequire('guaI6'));

});

parcelRegister("9RRKT", function(module, exports) {

let $72f2c2ffce0668ed$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $72f2c2ffce0668ed$var$load("l42ar").then(()=>parcelRequire('4V1hx'));

});

parcelRegister("iGsKW", function(module, exports) {

let $03829ec8c2573ac3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $03829ec8c2573ac3$var$load("5erPe").then(()=>parcelRequire('ddr0p'));

});

parcelRegister("4RtEN", function(module, exports) {

let $38a31dea5aeaf332$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $38a31dea5aeaf332$var$load("hlqS1").then(()=>parcelRequire('9wTHj'));

});

parcelRegister("kMOBw", function(module, exports) {

let $f21f8b4932690940$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f21f8b4932690940$var$load("cXodu").then(()=>parcelRequire('aH2D0'));

});

parcelRegister("9S0Uv", function(module, exports) {

let $72f9dcff84ce120c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $72f9dcff84ce120c$var$load("8PsNg"),
    $72f9dcff84ce120c$var$load("3vYMs")
]).then(()=>parcelRequire('ekFKF'));

});

parcelRegister("dvFpI", function(module, exports) {

let $9d5e4b84bf86b442$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9d5e4b84bf86b442$var$load("d1W0Z"),
    $9d5e4b84bf86b442$var$load("9UmxH")
]).then(()=>parcelRequire('jwRB3'));

});

parcelRegister("kqDAR", function(module, exports) {

let $edf4f2c8cfe437f6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $edf4f2c8cfe437f6$var$load("aQnhg"),
    $edf4f2c8cfe437f6$var$load("hlgZa")
]).then(()=>parcelRequire('lAsab'));

});

parcelRegister("1tPAM", function(module, exports) {

let $11408508ff918b90$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $11408508ff918b90$var$load("2nh75"),
    $11408508ff918b90$var$load("acQiP")
]).then(()=>parcelRequire('3gPdG'));

});

parcelRegister("cSCYi", function(module, exports) {

let $9608c21d130b72e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9608c21d130b72e8$var$load("jaTPo"),
    $9608c21d130b72e8$var$load("jSJrn")
]).then(()=>parcelRequire('33aqb'));

});

parcelRegister("lp57s", function(module, exports) {

let $f94fe75a2819acb2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f94fe75a2819acb2$var$load("dkV2T"),
    $f94fe75a2819acb2$var$load("kgJcP")
]).then(()=>parcelRequire('4azDt'));

});

parcelRegister("2q5WZ", function(module, exports) {

let $1c32a01a1687e7ba$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1c32a01a1687e7ba$var$load("9f4oR"),
    $1c32a01a1687e7ba$var$load("513ba")
]).then(()=>parcelRequire('5MyoV'));

});

parcelRegister("gfVkp", function(module, exports) {

let $bd5a8436c34d5e98$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bd5a8436c34d5e98$var$load("kefuj").then(()=>parcelRequire('d92Sa'));

});

parcelRegister("hgbfX", function(module, exports) {

let $c90ca98fe3f4ead2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c90ca98fe3f4ead2$var$load("bWqqo").then(()=>parcelRequire('54WGm'));

});

parcelRegister("d4dgh", function(module, exports) {

let $9835ef9160e26f5d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9835ef9160e26f5d$var$load("9ZeC1").then(()=>parcelRequire('4Xn5l'));

});

parcelRegister("8gGKC", function(module, exports) {

let $6050fac73242c69b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6050fac73242c69b$var$load("9zpNb").then(()=>parcelRequire('3lNRx'));

});

parcelRegister("eHEdz", function(module, exports) {

let $ab444746a2840683$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ab444746a2840683$var$load("gOpe6").then(()=>parcelRequire('agboS'));

});

parcelRegister("9B7dU", function(module, exports) {

let $6fcd2c2c2361cf2c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6fcd2c2c2361cf2c$var$load("RAL03").then(()=>parcelRequire('6EZU4'));

});

parcelRegister("dJ8xq", function(module, exports) {

let $9fe619cc9522aab1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fe619cc9522aab1$var$load("5nQIT").then(()=>parcelRequire('6Ft10'));

});

parcelRegister("8snbs", function(module, exports) {

let $6282ec126a48e044$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6282ec126a48e044$var$load("l9frT").then(()=>parcelRequire('ekSUX'));

});

parcelRegister("h7AKi", function(module, exports) {

let $c76f980be20ced01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c76f980be20ced01$var$load("lACXG").then(()=>parcelRequire('k3QR4'));

});

parcelRegister("3FWbZ", function(module, exports) {

let $2ad2573b4aebc3d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ad2573b4aebc3d3$var$load("ao5oO").then(()=>parcelRequire('dATVH'));

});

parcelRegister("jjUMn", function(module, exports) {

let $e10bd5dba5871395$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e10bd5dba5871395$var$load("7owaE").then(()=>parcelRequire('dTP2L'));

});

parcelRegister("8fzGq", function(module, exports) {

let $601b67668abeb62a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $601b67668abeb62a$var$load("9DPul"),
    $601b67668abeb62a$var$load("9PQvE")
]).then(()=>parcelRequire('4rZmd'));

});

parcelRegister("1JBYF", function(module, exports) {

let $143773ee0c2d5ff1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $143773ee0c2d5ff1$var$load("9FBaW").then(()=>parcelRequire('7D93v'));

});

parcelRegister("4auN3", function(module, exports) {

let $308ffae14e737c2e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $308ffae14e737c2e$var$load("hl2oi"),
    $308ffae14e737c2e$var$load("9dfxa")
]).then(()=>parcelRequire('cOAGo'));

});


parcelRegister("5MkWK", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $9dd53b67e285af98$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $9dd53b67e285af98$export$eaff10f7ec59c455);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");

var $1xKpK = parcelRequire("1xKpK");

var $eIleF = parcelRequire("eIleF");

var $6q0AE = parcelRequire("6q0AE");

var $dh538 = parcelRequire("dh538");

var $lz9QA = parcelRequire("lz9QA");

var $lgqac = parcelRequire("lgqac");
const $9dd53b67e285af98$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $1xKpK.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $9dd53b67e285af98$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $lgqac.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $9dd53b67e285af98$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const state = store ? (0, $6q0AE.getUrl)(store, url) : undefined;
    return (0, $gwFzn.useMemo)(()=>{
        return $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $9dd53b67e285af98$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $lz9QA.useSmartCardState)(url);
    const data = $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("lz9QA", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $206782ec364200b6$export$b0444d00ba7313c6);

var $bxoVL = parcelRequire("bxoVL");

var $eIleF = parcelRequire("eIleF");
const $206782ec364200b6$var$PENDING_STATE = {
    status: 'pending'
};
function $206782ec364200b6$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const cardState = (0, $bxoVL.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $206782ec364200b6$var$PENDING_STATE;
}

});


parcelRegister("9E8aG", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $c224b37846f1c464$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $c224b37846f1c464$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $c224b37846f1c464$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $c224b37846f1c464$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $c224b37846f1c464$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $c224b37846f1c464$export$c0547b4405cae584);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $hkQwp = parcelRequire("hkQwp");
var $5znEc = parcelRequire("5znEc");
var $Y5kOr = parcelRequire("Y5kOr");
var $8NpDA = parcelRequire("8NpDA");

var $2gWqY = parcelRequire("2gWqY");
const $c224b37846f1c464$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $dh538.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).some((child)=>$c224b37846f1c464$export$df0092b19156b140(child))) return true;
    return false;
};
const $c224b37846f1c464$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $c224b37846f1c464$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($hkQwp).some((type)=>type === node.type)) return true;
    return false;
};
const $c224b37846f1c464$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if (Object.values($2gWqY).some((type)=>type === node.type)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if (node.type === (0, $5znEc.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if (node.type === (0, $Y5kOr.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node) && node.type === (0, $8NpDA.default);

});
parcelRegister("hkQwp", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("8NpDA")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("1lLfV")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("Y5kOr")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("8zS2j")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("5znEc")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("2R1C4")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("jsdg1")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("eqpYq")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("MlN47")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("f0wtW")).default);

var $8NpDA = parcelRequire("8NpDA");

var $1lLfV = parcelRequire("1lLfV");

var $Y5kOr = parcelRequire("Y5kOr");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");

var $2R1C4 = parcelRequire("2R1C4");

var $jsdg1 = parcelRequire("jsdg1");

var $eqpYq = parcelRequire("eqpYq");

var $MlN47 = parcelRequire("MlN47");

var $f0wtW = parcelRequire("f0wtW");

});
parcelRegister("8NpDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d13bf310395f75$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $jsdg1 = parcelRequire("jsdg1");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $64d13bf310395f75$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jsdg1.default), {
        ...props,
        testId: testId
    });
};
var $64d13bf310395f75$export$2e2bcd8739ae039 = $64d13bf310395f75$var$FooterBlock;

});
parcelRegister("jsdg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a88c936354623c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4P6U3 = parcelRequire("4P6U3");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $2gWqY = parcelRequire("2gWqY");

var $7d67T = parcelRequire("7d67T");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");

var $l7DP7 = parcelRequire("l7DP7");
const $a5a88c936354623c$var$actionGroupStylesOld = null;
const $a5a88c936354623c$var$actionGroupStyles = null;
const $a5a88c936354623c$var$safariStyles = null;
const $a5a88c936354623c$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5TXU5.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const hasActions = (0, $gwFzn.useMemo)(()=>(0, $l7DP7.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const { safari: safari = false } = (0, $dh538.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gwFzn.useMemo)(()=>(0, $4P6U3.browser)(), []) : {};
    const onDropdownOpenChange = (0, $gwFzn.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gWqY.Provider), {
                ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                testId: "smart-element-group-actions",
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                className: (0, $35pXk.default)([
                    size === (0, $5TXU5.SmartLinkSize).XLarge && (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_c71lxy5q",
                    size === (0, $5TXU5.SmartLinkSize).XLarge && !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_c71lviql",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7d67T.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $a5a88c936354623c$export$2e2bcd8739ae039 = $a5a88c936354623c$var$FooterBlockResolvedView;

});
parcelRegister("fUfR2", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $6e7308c6380408ec$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $6e7308c6380408ec$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $6e7308c6380408ec$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $6e7308c6380408ec$export$e6b5ad18b56e8f51);

var $gwFzn = parcelRequire("gwFzn");
const $6e7308c6380408ec$export$ca70b164b615de47 = (0, $gwFzn.createContext)(undefined);
const $6e7308c6380408ec$export$61d7957a243df7aa = ()=>(0, $gwFzn.useContext)($6e7308c6380408ec$export$ca70b164b615de47);
const $6e7308c6380408ec$export$f7433dbd6c50e26a = (0, $gwFzn.createContext)(undefined);
const $6e7308c6380408ec$export$e6b5ad18b56e8f51 = ()=>(0, $gwFzn.useContext)($6e7308c6380408ec$export$f7433dbd6c50e26a);

});

parcelRegister("2gWqY", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $fc43eed0c473a139$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $fc43eed0c473a139$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $fc43eed0c473a139$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $fc43eed0c473a139$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $fc43eed0c473a139$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $fc43eed0c473a139$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $fc43eed0c473a139$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $fc43eed0c473a139$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $fc43eed0c473a139$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $fc43eed0c473a139$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $fc43eed0c473a139$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $fc43eed0c473a139$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $fc43eed0c473a139$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $fc43eed0c473a139$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $fc43eed0c473a139$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $fc43eed0c473a139$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $fc43eed0c473a139$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $fc43eed0c473a139$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $fc43eed0c473a139$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $fc43eed0c473a139$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $fc43eed0c473a139$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $fc43eed0c473a139$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $fc43eed0c473a139$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $fc43eed0c473a139$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $fc43eed0c473a139$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $fc43eed0c473a139$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $fc43eed0c473a139$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $fc43eed0c473a139$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $fc43eed0c473a139$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $fc43eed0c473a139$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $fc43eed0c473a139$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $fc43eed0c473a139$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("bCoGW")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("49WiA")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("gZvFP")).default);

var $5TXU5 = parcelRequire("5TXU5");

var $1Yyfz = parcelRequire("1Yyfz");

var $bCoGW = parcelRequire("bCoGW");

var $49WiA = parcelRequire("49WiA");

var $gZvFP = parcelRequire("gZvFP");
const $fc43eed0c473a139$export$d3af56c23f9e459b = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).AssignedTo);
const $fc43eed0c473a139$export$fbd18f11bf3a3444 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).AssignedToGroup);
const $fc43eed0c473a139$export$3bc3c9693a40aa = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).AttachmentCount);
const $fc43eed0c473a139$export$2ae2af4435dd6144 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).AuthorGroup);
const $fc43eed0c473a139$export$5742b38fd5cfe410 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ChecklistProgress);
const $fc43eed0c473a139$export$a1e647014985ddb9 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).CollaboratorGroup);
const $fc43eed0c473a139$export$f4c1466e6fdd07b = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).CommentCount);
const $fc43eed0c473a139$export$53ced9403d373871 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).CreatedOn);
const $fc43eed0c473a139$export$db468caedefbb630 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).CreatedBy);
const $fc43eed0c473a139$export$fea59459cfa1625b = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).DueOn);
const $fc43eed0c473a139$export$2aa8c58ab6c8ae64 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).LatestCommit);
const $fc43eed0c473a139$export$69387b41dfc808f7 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).LinkIcon);
const $fc43eed0c473a139$export$18a2be9195644f38 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).Location);
const $fc43eed0c473a139$export$ebbbdcc68d717b7b = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ModifiedBy);
const $fc43eed0c473a139$export$a6db3f4240728b58 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ModifiedOn);
const $fc43eed0c473a139$export$fa04b1f8d953704f = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).OwnedBy);
const $fc43eed0c473a139$export$90e81c873cca1e90 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).OwnedByGroup);
const $fc43eed0c473a139$export$300334f671c43555 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).Priority);
const $fc43eed0c473a139$export$7904b5485bf997ea = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ProgrammingLanguage);
const $fc43eed0c473a139$export$2881499e37b75b9a = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).Provider);
const $fc43eed0c473a139$export$f69df2decd5f729e = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ReactCount);
const $fc43eed0c473a139$export$77dedcd16f070a20 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ReadTime);
const $fc43eed0c473a139$export$897b145a1ed39fe5 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).SentOn);
const $fc43eed0c473a139$export$387c3264a8f67d61 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).SourceBranch);
const $fc43eed0c473a139$export$7254cc27399e90bd = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).State);
const $fc43eed0c473a139$export$cfafe90bba8a54db = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).SubscriberCount);
const $fc43eed0c473a139$export$d441f34e4c8dd9e7 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).SubTasksProgress);
const $fc43eed0c473a139$export$634eef04d1a9a575 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).StoryPoints);
const $fc43eed0c473a139$export$b5e4199e062b8f44 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).TargetBranch);
const $fc43eed0c473a139$export$f99233281efd08a0 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).Title);
const $fc43eed0c473a139$export$ae2d8be089b6cfe0 = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).ViewCount);
const $fc43eed0c473a139$export$b080bef6ed7fa75a = (0, $1Yyfz.createElement)((0, $5TXU5.ElementName).VoteCount);

});
parcelRegister("1Yyfz", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $6ad40a3d7e2f83fb$export$c8a8987d4410bf2d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $ivUmx = parcelRequire("ivUmx");

var $gZvFP = parcelRequire("gZvFP");

var $132Vf = parcelRequire("132Vf");

var $9HNxP = parcelRequire("9HNxP");

var $hJrcJ = parcelRequire("hJrcJ");

var $9HNG8 = parcelRequire("9HNG8");

var $749L9 = parcelRequire("749L9");

var $lLQB9 = parcelRequire("lLQB9");

var $h2SDv = parcelRequire("h2SDv");

var $laAw7 = parcelRequire("laAw7");

var $l02kL = parcelRequire("l02kL");
const $6ad40a3d7e2f83fb$var$elementMappings = {
    [(0, $5TXU5.ElementName).AppliedToComponentsCount]: {
        component: (0, $gZvFP.default),
        props: {
            icon: (0, $5TXU5.IconType).Component
        }
    },
    [(0, $5TXU5.ElementName).AttachmentCount]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).Attachment
        }
    },
    [(0, $5TXU5.ElementName).AuthorGroup]: {
        component: (0, $9HNxP.default)
    },
    [(0, $5TXU5.ElementName).ChecklistProgress]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).CheckItem
        }
    },
    [(0, $5TXU5.ElementName).CollaboratorGroup]: {
        component: (0, $9HNxP.default)
    },
    [(0, $5TXU5.ElementName).CommentCount]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).Comment
        }
    },
    [(0, $5TXU5.ElementName).ViewCount]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).View
        }
    },
    [(0, $5TXU5.ElementName).ReactCount]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).React
        }
    },
    [(0, $5TXU5.ElementName).VoteCount]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).Vote
        }
    },
    [(0, $5TXU5.ElementName).CreatedBy]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).OwnedBy]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).AssignedTo]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).AssignedToGroup]: {
        component: (0, $9HNxP.default)
    },
    [(0, $5TXU5.ElementName).OwnedByGroup]: {
        component: (0, $9HNxP.default)
    },
    [(0, $5TXU5.ElementName).CreatedOn]: {
        component: (0, $9HNG8.default)
    },
    [(0, $5TXU5.ElementName).DueOn]: {
        component: (0, $h2SDv.default)
    },
    [(0, $5TXU5.ElementName).LatestCommit]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).Commit
        }
    },
    [(0, $5TXU5.ElementName).LinkIcon]: {
        component: (0, $749L9.default)
    },
    [(0, $5TXU5.ElementName).ModifiedBy]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).ModifiedOn]: {
        component: (0, $9HNG8.default)
    },
    [(0, $5TXU5.ElementName).Preview]: {
        component: (0, $laAw7.default)
    },
    [(0, $5TXU5.ElementName).Priority]: {
        component: (0, $hJrcJ.default)
    },
    [(0, $5TXU5.ElementName).ProgrammingLanguage]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).ProgrammingLanguage
        }
    },
    [(0, $5TXU5.ElementName).Provider]: {
        component: (0, $hJrcJ.default)
    },
    [(0, $5TXU5.ElementName).ReadTime]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).SentOn]: {
        component: (0, $9HNG8.default)
    },
    [(0, $5TXU5.ElementName).SourceBranch]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).State]: {
        component: (0, $h2SDv.default)
    },
    [(0, $5TXU5.ElementName).SubscriberCount]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).Subscriber
        }
    },
    [(0, $5TXU5.ElementName).SubTasksProgress]: {
        component: (0, $hJrcJ.default),
        props: {
            icon: (0, $5TXU5.IconType).SubTasksProgress
        }
    },
    [(0, $5TXU5.ElementName).StoryPoints]: {
        component: (0, $132Vf.default)
    },
    [(0, $5TXU5.ElementName).TargetBranch]: {
        component: (0, $l02kL.default)
    },
    [(0, $5TXU5.ElementName).Title]: {
        component: (0, $lLQB9.default)
    },
    [(0, $5TXU5.ElementName).Location]: {
        component: (0, $lLQB9.default),
        props: {
            theme: (0, $5TXU5.SmartLinkInternalTheme).Grey
        }
    }
};
const $6ad40a3d7e2f83fb$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $6ad40a3d7e2f83fb$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $5TXU5.ElementName).AssignedToGroup:
        case (0, $5TXU5.ElementName).AuthorGroup:
        case (0, $5TXU5.ElementName).CollaboratorGroup:
        case (0, $5TXU5.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $5TXU5.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $6ad40a3d7e2f83fb$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $5TXU5.ElementName).AppliedToComponentsCount:
        case (0, $5TXU5.ElementName).AttachmentCount:
        case (0, $5TXU5.ElementName).ChecklistProgress:
        case (0, $5TXU5.ElementName).CommentCount:
        case (0, $5TXU5.ElementName).ViewCount:
        case (0, $5TXU5.ElementName).ReactCount:
        case (0, $5TXU5.ElementName).VoteCount:
        case (0, $5TXU5.ElementName).ProgrammingLanguage:
        case (0, $5TXU5.ElementName).SubscriberCount:
        case (0, $5TXU5.ElementName).LatestCommit:
        case (0, $5TXU5.ElementName).SubTasksProgress:
            return $6ad40a3d7e2f83fb$var$toBadgeProps(data);
        case (0, $5TXU5.ElementName).StoryPoints:
            return $6ad40a3d7e2f83fb$var$toAtlaskitBadgeProps(data);
        case (0, $5TXU5.ElementName).CreatedBy:
            return $6ad40a3d7e2f83fb$var$toFormattedTextProps((0, $afp1H.messages).created_by, context.createdBy);
        case (0, $5TXU5.ElementName).AssignedTo:
            return $6ad40a3d7e2f83fb$var$toFormattedTextProps((0, $afp1H.messages).assigned_to, context.assignedTo);
        case (0, $5TXU5.ElementName).OwnedBy:
            return $6ad40a3d7e2f83fb$var$toFormattedTextProps((0, $afp1H.messages).owned_by, context.ownedBy);
        case (0, $5TXU5.ElementName).CreatedOn:
            return $6ad40a3d7e2f83fb$var$toDateTimeProps('created', context.createdOn);
        case (0, $5TXU5.ElementName).DueOn:
            return $6ad40a3d7e2f83fb$var$toDateLozengeProps(context.dueOn);
        case (0, $5TXU5.ElementName).ModifiedBy:
            return $6ad40a3d7e2f83fb$var$toFormattedTextProps((0, $afp1H.messages).modified_by, context.modifiedBy);
        case (0, $5TXU5.ElementName).ModifiedOn:
            return $6ad40a3d7e2f83fb$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $5TXU5.ElementName).SentOn:
            return $6ad40a3d7e2f83fb$var$toDateTimeProps('sent', context.sentOn);
        case (0, $5TXU5.ElementName).ReadTime:
            return $6ad40a3d7e2f83fb$var$toFormattedTextProps((0, $afp1H.messages).read_time, data);
        case (0, $5TXU5.ElementName).SourceBranch:
        case (0, $5TXU5.ElementName).TargetBranch:
            return $6ad40a3d7e2f83fb$var$toTextProps(data);
        case (0, $5TXU5.ElementName).Title:
            return $6ad40a3d7e2f83fb$var$toLinkProps(context.title, context.url);
        case (0, $5TXU5.ElementName).LinkIcon:
            if ((0, $dh538.fg)('platform-linking-visual-refresh-v2')) return $6ad40a3d7e2f83fb$var$toLinkIconProps(data, context.type);
            return typeof data === 'object' ? data : undefined;
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $6ad40a3d7e2f83fb$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $6ad40a3d7e2f83fb$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toFormattedTextProps = (descriptor, context)=>{
    if ((0, $dh538.fg)('platform-linking-additional-flexible-element-props')) return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $6ad40a3d7e2f83fb$var$toLinkIconProps = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $ivUmx.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};
const $6ad40a3d7e2f83fb$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $6ad40a3d7e2f83fb$var$elementMappings[name] || {};
    const contextKey = $6ad40a3d7e2f83fb$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $gwFzn.useContext)((0, $fUfR2.FlexibleUiContext));
        const data = $6ad40a3d7e2f83fb$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, $7UHDa.jsx)(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("gZvFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e3f2d960c488f2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $hJrcJ = parcelRequire("hJrcJ");
const $49e3f2d960c488f2$var$AppliedToComponentsCount = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const context = (0, $gwFzn.useContext)((0, $fUfR2.FlexibleUiContext));
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $afp1H.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hJrcJ.default), {
        icon: (0, $5TXU5.IconType).Component,
        label: label,
        ...props
    });
};
var $49e3f2d960c488f2$export$2e2bcd8739ae039 = $49e3f2d960c488f2$var$AppliedToComponentsCount;

});
parcelRegister("hJrcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e8f9c47bb4a5531$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $iFRRf = parcelRequire("iFRRf");

var $kUxzQ = parcelRequire("kUxzQ");

var $1iDg7 = parcelRequire("1iDg7");

var $hJgLA = parcelRequire("hJgLA");
const $5e8f9c47bb4a5531$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $5e8f9c47bb4a5531$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $5e8f9c47bb4a5531$var$badgeStyles = null;
const $5e8f9c47bb4a5531$var$iconStyles = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $5e8f9c47bb4a5531$var$labelStylesOld = null;
const $5e8f9c47bb4a5531$var$messageMapper = {
    [(0, $5TXU5.IconType).PriorityBlocker]: (0, $afp1H.messages).priority_blocker,
    [(0, $5TXU5.IconType).PriorityCritical]: (0, $afp1H.messages).priority_critical,
    [(0, $5TXU5.IconType).PriorityHigh]: (0, $afp1H.messages).priority_high,
    [(0, $5TXU5.IconType).PriorityHighest]: (0, $afp1H.messages).priority_highest,
    [(0, $5TXU5.IconType).PriorityLow]: (0, $afp1H.messages).priority_low,
    [(0, $5TXU5.IconType).PriorityLowest]: (0, $afp1H.messages).priority_lowest,
    [(0, $5TXU5.IconType).PriorityMajor]: (0, $afp1H.messages).priority_major,
    [(0, $5TXU5.IconType).PriorityMedium]: (0, $afp1H.messages).priority_medium,
    [(0, $5TXU5.IconType).PriorityMinor]: (0, $afp1H.messages).priority_minor,
    [(0, $5TXU5.IconType).PriorityTrivial]: (0, $afp1H.messages).priority_trivial,
    [(0, $5TXU5.IconType).PriorityUndefined]: (0, $afp1H.messages).priority_undefined
};
const $5e8f9c47bb4a5531$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $5e8f9c47bb4a5531$var$messageMapper[icon];
        if (descriptor) return (0, $hJgLA.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $5e8f9c47bb4a5531$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iFRRf.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $5e8f9c47bb4a5531$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUxzQ.default), {
        testId: testId,
        url: url
    });
}; /**
    * A base element that displays some text with an associated icon.
    * @internal
    * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
    * @see CommentCount
    * @see ViewCount
    * @see ReactCount
    * @see VoteCount
    * @see SubscriberCount
    * @see Priority
    * @see ProgrammingLanguage
    * @see Provider
    */ 
const $5e8f9c47bb4a5531$var$BadgeRefreshNew = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url }, ref)=>{
    const formattedMessageOrLabel = $5e8f9c47bb4a5531$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $5e8f9c47bb4a5531$var$renderAtlaskitIcon(icon, testId) || $5e8f9c47bb4a5531$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        className: (0, $35pXk.default)([
            $5e8f9c47bb4a5531$var$styles.container,
            $5e8f9c47bb4a5531$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $5e8f9c47bb4a5531$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $5e8f9c47bb4a5531$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
}); // On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(Badge);
const $5e8f9c47bb4a5531$var$BadgeRefreshNewWithOverrideCss = (0, $1iDg7.withOverrideCss)($5e8f9c47bb4a5531$var$BadgeRefreshNew); /**
                                                                          * A base element that displays some text with an associated icon.
                                                                          * @internal
                                                                          * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
                                                                          * @see CommentCount
                                                                          * @see ViewCount
                                                                          * @see ReactCount
                                                                          * @see VoteCount
                                                                          * @see SubscriberCount
                                                                          * @see Priority
                                                                          * @see ProgrammingLanguage
                                                                          * @see Provider
                                                                          */ 
const $5e8f9c47bb4a5531$var$BadgeCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $5e8f9c47bb4a5531$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $5e8f9c47bb4a5531$var$renderAtlaskitIcon(icon, testId) || $5e8f9c47bb4a5531$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $35pXk.default)([
                    "_11c8dcr7 _syaz131l _19bvv77o _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
const $5e8f9c47bb4a5531$var$Badge = (props)=>{
    if ((0, $dh538.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $7UHDa.jsx)($5e8f9c47bb4a5531$var$BadgeRefreshNewWithOverrideCss, {
        ...props
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)($5e8f9c47bb4a5531$var$BadgeCompiledNew, {
        ...props
    });
};
var $5e8f9c47bb4a5531$export$2e2bcd8739ae039 = $5e8f9c47bb4a5531$var$Badge;

});
parcelRegister("iFRRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $536366acab81aece$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4wH3g = parcelRequire("4wH3g");

var $7skR0 = parcelRequire("7skR0");
var $eO4W8 = parcelRequire("eO4W8");

var $7r4Rz = parcelRequire("7r4Rz");

var $GFtWS = parcelRequire("GFtWS");

var $9SMct = parcelRequire("9SMct");

var $5TXU5 = parcelRequire("5TXU5");

var $ivUmx = parcelRequire("ivUmx");
const $536366acab81aece$var$getIconImportFn = (icon, size)=>{
    const item = (0, $ivUmx.getLazyIcons)()[icon];
    if ((0, $ivUmx.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $536366acab81aece$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $536366acab81aece$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5TXU5.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5TXU5.IconType).Document:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9SMct.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5TXU5.IconType).Blog:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7r4Rz.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5TXU5.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $GFtWS.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $536366acab81aece$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $536366acab81aece$var$importIcon(importFn);
    switch(icon){
        case (0, $5TXU5.IconType).Confluence:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7skR0.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xsmall'
            });
        case (0, $5TXU5.IconType).Jira:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eO4W8.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xsmall'
            });
        case (0, $5TXU5.IconType).Error:
        case (0, $5TXU5.IconType).Forbidden:
            return /*#__PURE__*/ (0, $7UHDa.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $7UHDa.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $536366acab81aece$export$2e2bcd8739ae039 = $536366acab81aece$var$AtlaskitIcon;

});
parcelRegister("GFtWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc75dd15b55d0661$export$2e2bcd8739ae039);

var $brDJd = parcelRequire("brDJd");

var $deok5 = parcelRequire("deok5");

var $7CgcZ = parcelRequire("7CgcZ");
const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $brDJd.default), (0, $deok5.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;

});


parcelRegister("kUxzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4091fe284214d9a3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fp8VN = parcelRequire("fp8VN");

var $dh538 = parcelRequire("dh538");

var $hT8Jj = parcelRequire("hT8Jj");
const $4091fe284214d9a3$var$styles = {
    roundImg: "_2rko14q2"
};
const $4091fe284214d9a3$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fp8VN))), {
        src: url,
        loading: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $35pXk.default)([
                appearance === 'round' && (0, $dh538.fg)('platform-linking-visual-refresh-v2') && $4091fe284214d9a3$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $4091fe284214d9a3$export$2e2bcd8739ae039 = $4091fe284214d9a3$var$ImageIcon;

});
parcelRegister("hT8Jj", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $0ee6375a3337d738$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $0ee6375a3337d738$var$animationNameStyles = null;
const $0ee6375a3337d738$var$loadingSkeletonStyle = null;
const $0ee6375a3337d738$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $35pXk.default)([
            "_2rkoyh40 _uiztglyw _bfhkh3tw _1itk1qw5 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("1iDg7", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $8ddce3b50e63e6e3$export$e0bdcacb944f1da6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $8ddce3b50e63e6e3$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $gwFzn.useRef)(null);
        (0, $gwFzn.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("hJgLA", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $ecdac2a9be051ad6$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $ecdac2a9be051ad6$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $ecdac2a9be051ad6$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $ecdac2a9be051ad6$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $ecdac2a9be051ad6$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $ecdac2a9be051ad6$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $ecdac2a9be051ad6$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $ecdac2a9be051ad6$export$619e376a425cb759);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $4wH3g = parcelRequire("4wH3g");

var $5TXU5 = parcelRequire("5TXU5");
const $ecdac2a9be051ad6$export$9d642f65a919fb93 = {
    [(0, $5TXU5.SmartLinkSize).Small]: 'none',
    [(0, $5TXU5.SmartLinkSize).Medium]: 'compact',
    [(0, $5TXU5.SmartLinkSize).Large]: 'compact',
    [(0, $5TXU5.SmartLinkSize).XLarge]: 'default'
};
const $ecdac2a9be051ad6$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...descriptor,
            values: values
        });
    }
};
const $ecdac2a9be051ad6$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $ecdac2a9be051ad6$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $ecdac2a9be051ad6$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "tmnOu",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $ecdac2a9be051ad6$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1.75;
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $ecdac2a9be051ad6$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $ecdac2a9be051ad6$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $ecdac2a9be051ad6$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("132Vf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b438c18d3f25e40$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $c4sKh = parcelRequire("c4sKh");

var $dh538 = parcelRequire("dh538");
const $7b438c18d3f25e40$var$badgeStylesOld = null;
const $7b438c18d3f25e40$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $7b438c18d3f25e40$var$AtlaskitBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
            children: value
        })
    });
};
var $7b438c18d3f25e40$export$2e2bcd8739ae039 = $7b438c18d3f25e40$var$AtlaskitBadge;

});

parcelRegister("9HNxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7392f4b1a47e2f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $2Pg7f = parcelRequire("2Pg7f");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $hJgLA = parcelRequire("hJgLA");
const $a7392f4b1a47e2f9$var$MAX_COUNT = 4;
const $a7392f4b1a47e2f9$var$styles = null;
const $a7392f4b1a47e2f9$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $a7392f4b1a47e2f9$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5TXU5.ElementName).AssignedToGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).assigned_to, personName);
        case (0, $5TXU5.ElementName).OwnedByGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).owned_by, personName);
        case (0, $5TXU5.ElementName).AuthorGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).created_by, personName);
        default:
            return personName;
    }
}; /**
    * A base element that displays a group of avatars.
    * @internal
    * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
    * @see AuthorGroup
    * @see CollaboratorGroup
    */ 
const $a7392f4b1a47e2f9$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $a7392f4b1a47e2f9$var$MAX_COUNT, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $dBxQj.default)();
    const data = (0, $gwFzn.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5TXU5.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $a7392f4b1a47e2f9$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $a7392f4b1a47e2f9$var$stylesMap[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Pg7f.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $a7392f4b1a47e2f9$export$2e2bcd8739ae039 = $a7392f4b1a47e2f9$var$AvatarGroup;

});

parcelRegister("9HNG8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6653ee9c7f3a925$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $67MrH = parcelRequire("67MrH");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $afp1H = parcelRequire("afp1H");
const $b6653ee9c7f3a925$var$stylesOld = null;
const $b6653ee9c7f3a925$var$styles = null;
const $b6653ee9c7f3a925$var$typeToDescriptorMap = {
    created: {
        relative: (0, $afp1H.messages).created_on_relative,
        absolute: (0, $afp1H.messages).created_on_absolute
    },
    modified: {
        relative: (0, $afp1H.messages).modified_on_relative,
        absolute: (0, $afp1H.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $afp1H.messages).sent_on_relative,
        absolute: (0, $afp1H.messages).sent_on_absolute
    }
}; /**
    * A base element that displays an ISO Timestamp in text.
    * @internal
    * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
    * @see CreatedOn
    * @see ModifiedOn
    * @see SentOn
    */ 
const $b6653ee9c7f3a925$var$DateTime = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $dBxQj.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $67MrH.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix && (0, $dh538.fg)('platform-linking-additional-flexible-element-props')) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...$b6653ee9c7f3a925$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: content
    });
};
var $b6653ee9c7f3a925$export$2e2bcd8739ae039 = $b6653ee9c7f3a925$var$DateTime;

});
parcelRegister("67MrH", function(module, exports) {

$parcel$export(module.exports, "selectUnit", () => $4758f9d23d9a881e$export$b8f7189986dd5395);
var $4758f9d23d9a881e$var$__assign = undefined && undefined.__assign || function() {
    $4758f9d23d9a881e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4758f9d23d9a881e$var$__assign.apply(this, arguments);
};
var $4758f9d23d9a881e$var$MS_PER_SECOND = 1e3;
var $4758f9d23d9a881e$var$SECS_PER_MIN = 60;
var $4758f9d23d9a881e$var$SECS_PER_HOUR = $4758f9d23d9a881e$var$SECS_PER_MIN * 60;
var $4758f9d23d9a881e$var$SECS_PER_DAY = $4758f9d23d9a881e$var$SECS_PER_HOUR * 24;
var $4758f9d23d9a881e$var$SECS_PER_WEEK = $4758f9d23d9a881e$var$SECS_PER_DAY * 7;
function $4758f9d23d9a881e$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $4758f9d23d9a881e$var$__assign($4758f9d23d9a881e$var$__assign({}, $4758f9d23d9a881e$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $4758f9d23d9a881e$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $4758f9d23d9a881e$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $4758f9d23d9a881e$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $4758f9d23d9a881e$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $4758f9d23d9a881e$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $4758f9d23d9a881e$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};

});


parcelRegister("749L9", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d7ad2accbbe09f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $8Q3VW = parcelRequire("8Q3VW");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $iFRRf = parcelRequire("iFRRf");

var $kUxzQ = parcelRequire("kUxzQ");

var $hJgLA = parcelRequire("hJgLA");
const $89d7ad2accbbe09f$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $89d7ad2accbbe09f$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $89d7ad2accbbe09f$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $89d7ad2accbbe09f$var$renderAtlaskitIcon = (icon, testId, size = (0, $5TXU5.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iFRRf.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $89d7ad2accbbe09f$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $89d7ad2accbbe09f$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance)=>{
    const width = size === (0, $5TXU5.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUxzQ.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v2') && {
            appearance: appearance
        }
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param {IconProps} IconProps - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $89d7ad2accbbe09f$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5TXU5.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square' })=>{
    const element = (0, $gwFzn.useMemo)(()=>{
        const defaultIcon = $89d7ad2accbbe09f$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $89d7ad2accbbe09f$var$renderImageIcon(defaultIcon, url, testId, size, (0, $dh538.fg)('platform-linking-visual-refresh-v2') ? appearance : undefined) || $89d7ad2accbbe09f$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        icon
    ]);
    const width = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $89d7ad2accbbe09f$var$styles.container,
            $89d7ad2accbbe09f$var$positionStyleMap[position],
            render && $89d7ad2accbbe09f$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: $89d7ad2accbbe09f$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $89d7ad2accbbe09f$export$2e2bcd8739ae039 = $89d7ad2accbbe09f$var$Icon;

});

parcelRegister("lLQB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4975140d722fb1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $5TXU5 = parcelRequire("5TXU5");

var $4gM1A = parcelRequire("4gM1A");

var $hJgLA = parcelRequire("hJgLA");
const $7c4975140d722fb1$var$DEFAULT_MAX_LINES = 2;
const $7c4975140d722fb1$var$MAXIMUM_MAX_LINES = 2;
const $7c4975140d722fb1$var$MINIMUM_MAX_LINES = 1;
const $7c4975140d722fb1$var$containerStyles = null;
const $7c4975140d722fb1$var$getMaxLines = (maxLines)=>{
    if (maxLines > $7c4975140d722fb1$var$MAXIMUM_MAX_LINES) return $7c4975140d722fb1$var$DEFAULT_MAX_LINES;
    if (maxLines < $7c4975140d722fb1$var$MINIMUM_MAX_LINES) return $7c4975140d722fb1$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $7c4975140d722fb1$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $7c4975140d722fb1$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $7c4975140d722fb1$var$baseAnchorStyle = null;
const $7c4975140d722fb1$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $7c4975140d722fb1$var$anchorConstantsStyles = null;
const $7c4975140d722fb1$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $7c4975140d722fb1$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $7c4975140d722fb1$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $7c4975140d722fb1$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
}; /**
    * A base element that represent an anchor.
    * @internal
    * @param {LinkProps} LinkProps - The props necessary for the Link element.
    * @see LinkIcon
    */ 
const $7c4975140d722fb1$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $7c4975140d722fb1$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5TXU5.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const hasSpace = (0, $gwFzn.useMemo)(()=>text ? (0, $hJgLA.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $7c4975140d722fb1$var$linkStyleSizeMap[size],
            $7c4975140d722fb1$var$anchorLineClampMap[$7c4975140d722fb1$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $7c4975140d722fb1$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $7c4975140d722fb1$var$getMaxLines(maxLines) === 1 && $7c4975140d722fb1$var$anchorLinkLineHeight1Map[size],
            $7c4975140d722fb1$var$getMaxLines(maxLines) === 2 && $7c4975140d722fb1$var$anchorLinkLineHeight2Map[size],
            $7c4975140d722fb1$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        children: text
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $7c4975140d722fb1$var$withTooltip(anchor, text, testId)
    });
};
var $7c4975140d722fb1$export$2e2bcd8739ae039 = $7c4975140d722fb1$var$Link;

});

parcelRegister("h2SDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a8a0e1dc699c9f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");

var $fUfR2 = parcelRequire("fUfR2");

var $8MuJU = parcelRequire("8MuJU");
const $f2a8a0e1dc699c9f$var$stylesOld = null;
const $f2a8a0e1dc699c9f$var$styles = null; /**
                      * A base element that displays a Lozenge.
                      * @internal
                      * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
                      * @see State
                      */ 
const $f2a8a0e1dc699c9f$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MuJU.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
        appearance: appearance,
        ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $f2a8a0e1dc699c9f$export$2e2bcd8739ae039 = $f2a8a0e1dc699c9f$var$Lozenge;

});
parcelRegister("8MuJU", function(module, exports) {

$parcel$export(module.exports, "default", () => $869b50e8f107037a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $52EPl = parcelRequire("52EPl");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $eJ92v = parcelRequire("eJ92v");

var $g98dH = parcelRequire("g98dH");

var $8i8ID = parcelRequire("8i8ID");

var $7DSoa = parcelRequire("7DSoa");

var $cOlaT = parcelRequire("cOlaT");

var $lgqac = parcelRequire("lgqac");

var $gSbwD = parcelRequire("gSbwD");

var $78b5a = parcelRequire("78b5a");

var $2SiF7 = parcelRequire("2SiF7");

var $eDqcO = parcelRequire("eDqcO");

var $5FY0o = parcelRequire("5FY0o");

var $fvEKY = parcelRequire("fvEKY");
const $869b50e8f107037a$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $869b50e8f107037a$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $gwFzn.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $gwFzn.useState)(false);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [items, setItems] = (0, $gwFzn.useState)();
    const [errorMessage, setErrorMessage] = (0, $gwFzn.useState)();
    const reload = (0, $7DSoa.default)();
    const invoke = (0, $g98dH.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $gwFzn.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $eJ92v.default));
                const validItems = typeof text === 'string' ? $869b50e8f107037a$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $78b5a.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $eDqcO.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $eDqcO.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $eDqcO.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $78b5a.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $gwFzn.useCallback)((props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $fvEKY.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $gwFzn.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $cOlaT.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8i8ID.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $78b5a.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $eDqcO.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $78b5a.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $gwFzn.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2SiF7.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5FY0o.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $869b50e8f107037a$export$2e2bcd8739ae039 = (0, $gSbwD.default)($869b50e8f107037a$var$LozengeAction);

});
parcelRegister("eJ92v", function(module, exports) {

$parcel$export(module.exports, "default", () => $de46c47a4ecd1eb4$export$2e2bcd8739ae039);
const $de46c47a4ecd1eb4$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $de46c47a4ecd1eb4$export$2e2bcd8739ae039 = $de46c47a4ecd1eb4$var$extractLozengeActionItems;

});

parcelRegister("g98dH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b01bbbcb1713fd75$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $htjmD = parcelRequire("htjmD");

var $eIleF = parcelRequire("eIleF");
const $b01bbbcb1713fd75$var$useInvoke = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const clientExt = (0, $htjmD.useSmartLinkClientExtension)(connections.client);
    return (0, $gwFzn.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b01bbbcb1713fd75$export$2e2bcd8739ae039 = $b01bbbcb1713fd75$var$useInvoke;

});
parcelRegister("htjmD", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $6bb10922c4ae303f$export$303ede4eed148855);

var $gwFzn = parcelRequire("gwFzn");

var $gmi3X = parcelRequire("gmi3X");

var $4X6f2 = parcelRequire("4X6f2");

var $1Okf1 = parcelRequire("1Okf1");
const $6bb10922c4ae303f$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $1Okf1.useResolverUrl)(cardClient);
    const invoke = (0, $gwFzn.useCallback)(async (data)=>{
        try {
            return await (0, $gmi3X.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $4X6f2.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("4X6f2", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $c5c90dd6b941df7e$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $c5c90dd6b941df7e$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $c5c90dd6b941df7e$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $c5c90dd6b941df7e$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}

});



parcelRegister("8i8ID", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $e9aefac4b34acc2c$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $e9aefac4b34acc2c$export$1694272377fa07d8);

var $lgqac = parcelRequire("lgqac");
const $e9aefac4b34acc2c$export$65b3f792dff0bd60 = (err)=>{
    if (!$e9aefac4b34acc2c$export$1694272377fa07d8(err)) return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $lgqac.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    }
};
const $e9aefac4b34acc2c$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("7DSoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe2ac6ef7785039$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $lyclm = parcelRequire("lyclm");

var $eIleF = parcelRequire("eIleF");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $bIll3 = parcelRequire("bIll3");

var $4IQbU = parcelRequire("4IQbU");
const $8fe2ac6ef7785039$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $4IQbU.default)();
    return (0, $gwFzn.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = (0, $dh538.fg)('smart_links_noun_support') ? !!(details && details.data || (0, $lyclm.isEntityPresent)(details)) : !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $bIll3.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $8fe2ac6ef7785039$export$2e2bcd8739ae039 = $8fe2ac6ef7785039$var$useResolve;

});
parcelRegister("4IQbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe444b12e732e06$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $eIleF = parcelRequire("eIleF");

var $9gPkz = parcelRequire("9gPkz");
var $jHnts = parcelRequire("jHnts");
var $btw9C = parcelRequire("btw9C");

var $5TXU5 = parcelRequire("5TXU5");

var $4ibS1 = parcelRequire("4ibS1");

var $bKqKH = parcelRequire("bKqKH");
const $afe444b12e732e06$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $gwFzn.useCallback)((url, metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $gwFzn.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: url
        }, (0, $4ibS1.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $gwFzn.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $gwFzn.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $btw9C.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fallback', hostname, (0, $bKqKH.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fatal', hostname, (0, $bKqKH.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('error', hostname, (0, $bKqKH.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $4FhhO.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $afe444b12e732e06$export$2e2bcd8739ae039 = $afe444b12e732e06$var$useResponse;

});
parcelRegister("4ibS1", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $edbc823e59ec01a7$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $edbc823e59ec01a7$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $edbc823e59ec01a7$export$e32193033a594efb);
const $edbc823e59ec01a7$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $edbc823e59ec01a7$export$2796a804c6e44f63 = ()=>$edbc823e59ec01a7$var$emptyData;
const $edbc823e59ec01a7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
const $edbc823e59ec01a7$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });

});

parcelRegister("bKqKH", function(module, exports) {

$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $96d7cda9026a4858$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $96d7cda9026a4858$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $96d7cda9026a4858$export$338f7d9ccca1975d);
const $96d7cda9026a4858$export$297c39c8b9bfca0 = 'resolving';
const $96d7cda9026a4858$export$b64a888338c24e0e = 'errored';
const $96d7cda9026a4858$export$677b6edfa0002c70 = 'fallback';
const $96d7cda9026a4858$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $96d7cda9026a4858$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $96d7cda9026a4858$export$338f7d9ccca1975d = 'Error resolving metadata.';

});



parcelRegister("cOlaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa24a5eb3eb20317$export$2e2bcd8739ae039);
const $fa24a5eb3eb20317$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $fa24a5eb3eb20317$export$2e2bcd8739ae039 = $fa24a5eb3eb20317$var$createStatusUpdateRequest;

});

parcelRegister("gSbwD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6650d05e02f39c7f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");
const $6650d05e02f39c7f$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                appearance: props?.appearance,
                ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    };
var $6650d05e02f39c7f$export$2e2bcd8739ae039 = $6650d05e02f39c7f$var$withErrorBoundary;

});

parcelRegister("78b5a", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $345056907ffbf67a$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $345056907ffbf67a$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $345056907ffbf67a$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $345056907ffbf67a$export$618660b8f2aa87e2);
const $345056907ffbf67a$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $345056907ffbf67a$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $345056907ffbf67a$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $345056907ffbf67a$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("2SiF7", function(module, exports) {

$parcel$export(module.exports, "default", () => $064cd0764f59feda$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $4jR19 = parcelRequire("4jR19");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $5L38b = parcelRequire("5L38b");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $9oOnT = parcelRequire("9oOnT");

var $hJgLA = parcelRequire("hJgLA");
const $064cd0764f59feda$var$MAX_LINE_NUMBER = 8;
const $064cd0764f59feda$var$contentStyles = null;
const $064cd0764f59feda$var$linkStyles = null;
const $064cd0764f59feda$var$textStylesBase = null;
const $064cd0764f59feda$var$dropdownItemGroupStyles = null;
const $064cd0764f59feda$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $064cd0764f59feda$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const invoke = (0, $9oOnT.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $gwFzn.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $gwFzn.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    className: (0, $35pXk.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: "var(--ds-icon-danger, #C9372C)",
                            LEGACY_secondaryColor: "var(--ds-background-danger, #FFECEB)",
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $35pXk.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $iAWao.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $hJgLA.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    className: (0, $35pXk.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $dh538.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $afp1H.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $afp1H.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $35pXk.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahaN7.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $064cd0764f59feda$export$2e2bcd8739ae039 = $064cd0764f59feda$var$LozengeActionError;

});
parcelRegister("9oOnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $458a31c3ca98bc55$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $9HkI0 = parcelRequire("9HkI0");

var $kKODE = parcelRequire("kKODE");

var $l6tPN = parcelRequire("l6tPN");

var $bIll3 = parcelRequire("bIll3");
const $458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $458a31c3ca98bc55$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $gwFzn.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $l6tPN.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $bIll3.startUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $l6tPN.mark(markName, 'resolved');
            (0, $bIll3.succeedUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $l6tPN.mark(markName, 'errored');
            (0, $bIll3.failUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $458a31c3ca98bc55$export$2e2bcd8739ae039 = $458a31c3ca98bc55$var$useInvokeClientAction;

});
parcelRegister("l6tPN", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $f72103dc56ec53a8$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $f72103dc56ec53a8$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $f72103dc56ec53a8$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $f72103dc56ec53a8$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $f72103dc56ec53a8$export$185802fd694ee1f5);
const $f72103dc56ec53a8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $f72103dc56ec53a8$var$hasPerformanceAPIAvailable = $f72103dc56ec53a8$var$isPerformanceAPIAvailable();
const $f72103dc56ec53a8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $f72103dc56ec53a8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $f72103dc56ec53a8$export$1a717feb4df1a945 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $f72103dc56ec53a8$export$de42547d395c8271 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $f72103dc56ec53a8$var$getMark = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $f72103dc56ec53a8$export$185802fd694ee1f5 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measure = $f72103dc56ec53a8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $f72103dc56ec53a8$var$getMark(id, 'pending');
            const endMark = $f72103dc56ec53a8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("eDqcO", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $00d6f6a41babe5ce$export$4f2e371a667ad688);

var $afp1H = parcelRequire("afp1H");
const $00d6f6a41babe5ce$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $afp1H.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $afp1H.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $afp1H.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $afp1H.messages)['status_change_update_error']
    }
};

});

parcelRegister("5FY0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97525520e73c14c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ahaN7 = parcelRequire("ahaN7");

var $cpZT8 = parcelRequire("cpZT8");
const $b97525520e73c14c$var$dropdownItemGroupStyles = null;
const $b97525520e73c14c$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $35pXk.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahaN7.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $cpZT8.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $b97525520e73c14c$export$2e2bcd8739ae039 = $b97525520e73c14c$var$LozengeActionItemsGroup;

});
parcelRegister("cpZT8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cba0aedda67d7b43$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");
const $cba0aedda67d7b43$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $gwFzn.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                appearance: appearance,
                ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $cba0aedda67d7b43$export$2e2bcd8739ae039 = $cba0aedda67d7b43$var$LozengeActionItem;

});


parcelRegister("fvEKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $af099bbb631b2118$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fk6ei = parcelRequire("fk6ei");

var $aIk0I = parcelRequire("aIk0I");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
const $af099bbb631b2118$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw"
};
const $af099bbb631b2118$var$triggerLozengeStyles = null;
const $af099bbb631b2118$var$triggerButtonStyles = null;
const $af099bbb631b2118$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $gwFzn.useState)(false);
    const onMouseEnter = (0, $gwFzn.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $gwFzn.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
            appearance: appearance,
            isBold: (0, $dh538.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
                className: (0, $35pXk.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $af099bbb631b2118$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fk6ei))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $35pXk.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $af099bbb631b2118$export$2e2bcd8739ae039 = $af099bbb631b2118$var$LozengeActionTrigger;

});



parcelRegister("laAw7", function(module, exports) {

$parcel$export(module.exports, "default", () => $681ff1120685c73b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kUxzQ = parcelRequire("kUxzQ");
const $681ff1120685c73b$var$styles = null; /**
                      * A base element that displays a Media.
                      * @internal
                      * @param {MediaProps} MediaProps - The props necessary for the Media element.
                      * @see Preview
                      */ 
const $681ff1120685c73b$var$Media = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUxzQ.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $681ff1120685c73b$export$2e2bcd8739ae039 = $681ff1120685c73b$var$Media;

});

parcelRegister("l02kL", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d1585c69a6804c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $dh538 = parcelRequire("dh538");

var $hJgLA = parcelRequire("hJgLA");
const $11d1585c69a6804c$var$baseStyleOld = null;
const $11d1585c69a6804c$var$baseStyle = null; /**
                         * A base element that displays some Text.
                         * @internal
                         * @param {TextProps} TextProps - The props necessary for the Text element.
                         * @see Title
                         */ 
const $11d1585c69a6804c$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const newContent = hideFormat && content ? content : (0, $hJgLA.getFormattedMessage)(message) || content;
    const oldContent = (0, $hJgLA.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            "--_1erfju8": (0, $iAWao.default)(maxLines)
        },
        children: (0, $dh538.fg)('platform-linking-additional-flexible-element-props') ? newContent : oldContent
    });
};
var $11d1585c69a6804c$export$2e2bcd8739ae039 = $11d1585c69a6804c$var$Text;

});


parcelRegister("bCoGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c2f5cfd4878fb2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $laAw7 = parcelRequire("laAw7");
const $d9c2f5cfd4878fb2$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $gwFzn.useContext)((0, $fUfR2.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5TXU5.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $laAw7.default), {
        ...rest,
        ...data
    });
};
var $d9c2f5cfd4878fb2$export$2e2bcd8739ae039 = $d9c2f5cfd4878fb2$var$Preview;

});

parcelRegister("49WiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2a6a0afaba68de$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $fUfR2 = parcelRequire("fUfR2");

var $l02kL = parcelRequire("l02kL");
const $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES = 3; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $4a2a6a0afaba68de$var$snippetBaseStyleOld = null;
const $4a2a6a0afaba68de$var$snippetBaseStyle = null;
const $4a2a6a0afaba68de$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $gwFzn.useContext)((0, $fUfR2.FlexibleUiContext));
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l02kL.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $4a2a6a0afaba68de$export$2e2bcd8739ae039 = $4a2a6a0afaba68de$var$SnippetElement;

});


parcelRegister("7d67T", function(module, exports) {

$parcel$export(module.exports, "default", () => $56632f4bfc993cb1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $RUXAI = parcelRequire("RUXAI");

var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");

var $52EPl = parcelRequire("52EPl");

var $8JHjV = parcelRequire("8JHjV");

var $dh538 = parcelRequire("dh538");

var $3gadb = parcelRequire("3gadb");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $hJgLA = parcelRequire("hJgLA");

var $l7DP7 = parcelRequire("l7DP7");

var $9CAD2 = parcelRequire("9CAD2");
const $56632f4bfc993cb1$var$stylesOld = null;
const $56632f4bfc993cb1$var$styles = null;
const $56632f4bfc993cb1$var$renderActionItems = (items = [], size = (0, $5TXU5.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9CAD2.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx)); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $56632f4bfc993cb1$var$ActionGroup = ({ items: items = [], size: size = (0, $5TXU5.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $RUXAI.di)((0, $52EPl.default));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const renderableActionItems = (0, $gwFzn.useMemo)(()=>(0, $l7DP7.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $gwFzn.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $gwFzn.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $gwFzn.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $gwFzn.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $hJgLA.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8JHjV))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $afp1H.messages).more_actions
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hArLp.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $56632f4bfc993cb1$export$2e2bcd8739ae039 = $56632f4bfc993cb1$var$ActionGroup;

});
parcelRegister("l7DP7", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $304e11160ef9ec7e$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $304e11160ef9ec7e$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $304e11160ef9ec7e$export$9678d3ca18bd7526);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $9E8aG = parcelRequire("9E8aG");

var $2gWqY = parcelRequire("2gWqY");

var $7d67T = parcelRequire("7d67T");

var $1RvsP = parcelRequire("1RvsP");
const $304e11160ef9ec7e$export$f942619ce67b1a41 = {
    [(0, $5TXU5.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Location]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Preview]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).State]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Title]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).VoteCount]: [
        'inline'
    ]
};
const $304e11160ef9ec7e$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1;
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $304e11160ef9ec7e$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node) && node.type === (0, $7d67T.default);
const $304e11160ef9ec7e$var$isElementDisplayValid = (name, display)=>{
    return $304e11160ef9ec7e$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $304e11160ef9ec7e$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $304e11160ef9ec7e$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node) && ((0, $9E8aG.isFlexibleUiElement)(node) || node.type === (0, $1RvsP.default));
const $304e11160ef9ec7e$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5TXU5.ActionName).DeleteAction:
            case (0, $5TXU5.ActionName).EditAction:
            case (0, $5TXU5.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5TXU5.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $304e11160ef9ec7e$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child)=>{
        if ($304e11160ef9ec7e$var$isElementOrElementGroup(child) || $304e11160ef9ec7e$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $304e11160ef9ec7e$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $2gWqY[name];
        const typedProps = props;
        if (Element && $304e11160ef9ec7e$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $7UHDa.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$304e11160ef9ec7e$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("1RvsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $16630f477b2fdaf3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $l7DP7 = parcelRequire("l7DP7");
const $16630f477b2fdaf3$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
}; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $16630f477b2fdaf3$var$baseStyleBySizeOld = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $16630f477b2fdaf3$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $16630f477b2fdaf3$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $16630f477b2fdaf3$var$baseStyleOld = null;
const $16630f477b2fdaf3$var$baseStyles = null;
const $16630f477b2fdaf3$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $16630f477b2fdaf3$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $16630f477b2fdaf3$var$horizontalStyleBase = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $16630f477b2fdaf3$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $16630f477b2fdaf3$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $16630f477b2fdaf3$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $16630f477b2fdaf3$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $16630f477b2fdaf3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $16630f477b2fdaf3$var$ElementGroup = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5TXU5.SmartLinkWidth).FitToContent, position: position = (0, $5TXU5.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5TXU5.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$baseStyleBySizeOld[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$baseStyleBySize[size],
            $16630f477b2fdaf3$var$baseStyleByDirection[direction],
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $16630f477b2fdaf3$var$alignmentStyleMap[align],
            "_1ul99by0",
            $16630f477b2fdaf3$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Left && $16630f477b2fdaf3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Right && $16630f477b2fdaf3$var$gapStylesRight[size],
            $16630f477b2fdaf3$var$positionStyle[position],
            className
        ]),
        children: (0, $l7DP7.renderChildren)(children, size)
    });
};
var $16630f477b2fdaf3$export$2e2bcd8739ae039 = $16630f477b2fdaf3$var$ElementGroup;

});


parcelRegister("9CAD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $98cfef5f1319cffc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jlQ9A = parcelRequire("jlQ9A");
const $98cfef5f1319cffc$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $gwFzn.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $98cfef5f1319cffc$export$2e2bcd8739ae039 = $98cfef5f1319cffc$var$ActionGroupItem;

});
parcelRegister("jlQ9A", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("6FZ6a")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("jLXEH")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("dVBHR")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("cLh5D")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("9l03X")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("2vLbR")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("apOlf")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("lVA2Y")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("fl0WE")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("loGLq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9Gqdx")).default);

var $6FZ6a = parcelRequire("6FZ6a");

var $jLXEH = parcelRequire("jLXEH");

var $dVBHR = parcelRequire("dVBHR");

var $cLh5D = parcelRequire("cLh5D");

var $9l03X = parcelRequire("9l03X");

var $2vLbR = parcelRequire("2vLbR");

var $apOlf = parcelRequire("apOlf");

var $lVA2Y = parcelRequire("lVA2Y");

var $fl0WE = parcelRequire("fl0WE");

var $loGLq = parcelRequire("loGLq");

var $9Gqdx = parcelRequire("9Gqdx");

});
parcelRegister("6FZ6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f726fde681f8fde$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $aQC9h = parcelRequire("aQC9h");

var $ax5FR = parcelRequire("ax5FR");

var $03f7c = parcelRequire("03f7c");

var $20gwM = parcelRequire("20gwM");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1f726fde681f8fde$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $03f7c.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20gwM.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ax5FR.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aQC9h.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1f726fde681f8fde$export$2e2bcd8739ae039 = $1f726fde681f8fde$var$Action;

});
parcelRegister("aQC9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0e9865fe28e398$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $9YwaJ = parcelRequire("9YwaJ");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");
var $7p4As = parcelRequire("7p4As");
var $dE1p6 = parcelRequire("dE1p6");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $3gadb = parcelRequire("3gadb");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $1iDg7 = parcelRequire("1iDg7");

var $hJgLA = parcelRequire("hJgLA");
const $0c0e9865fe28e398$var$IconOnlyLarge = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$SizeSmall = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$SizeSmallIconOnly = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$SizeSmallNotIconOnly = null;
const $0c0e9865fe28e398$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $0c0e9865fe28e398$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $0c0e9865fe28e398$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $0c0e9865fe28e398$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $gwFzn.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $gwFzn.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dE1p6.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $0c0e9865fe28e398$var$ActionButtonRefreshNewWithOverrideCss = (0, $1iDg7.withOverrideCss)($0c0e9865fe28e398$var$ActionButtonRefreshNew); // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $gwFzn.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            size === (0, $5TXU5.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5TXU5.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5TXU5.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $5TXU5.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9YwaJ.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $hJgLA.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $0c0e9865fe28e398$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $dh538.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonNew, {
        ...props
    });
};
const $0c0e9865fe28e398$var$ActionButton = (props)=>{
    return (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonNew, {
        ...props
    });
};
var $0c0e9865fe28e398$export$2e2bcd8739ae039 = $0c0e9865fe28e398$var$ActionButton;

});

parcelRegister("ax5FR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e516599d84c6e93$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $ivUmx = parcelRequire("ivUmx");
const $4e516599d84c6e93$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $ivUmx.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4e516599d84c6e93$export$2e2bcd8739ae039 = $4e516599d84c6e93$var$ActionDropdownItem;

});

parcelRegister("03f7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9e773a3279151b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");
const $cc9e773a3279151b$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $cc9e773a3279151b$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
}; // TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $cc9e773a3279151b$var$stackItemIconStylesOld = null;
const $cc9e773a3279151b$var$stackItemIconStylesCompiled = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $cc9e773a3279151b$var$iconStyleMap = {
    true: "_syaz1lh4",
    false: "_syazwdcn"
};
const $cc9e773a3279151b$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cc9e773a3279151b$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $cc9e773a3279151b$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $cc9e773a3279151b$var$iconSizeStyleMap[$cc9e773a3279151b$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cc9e773a3279151b$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $cc9e773a3279151b$export$2e2bcd8739ae039 = $cc9e773a3279151b$var$ActionIcon;

});

parcelRegister("20gwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e828a55eaf50791b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $j1jJO = parcelRequire("j1jJO");
const $e828a55eaf50791b$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j1jJO.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $j1jJO.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $e828a55eaf50791b$export$2e2bcd8739ae039 = $e828a55eaf50791b$var$ActionStackItem;

});
parcelRegister("j1jJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb337baea8f1bcdf$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $fVUfS = parcelRequire("fVUfS");

var $9hlns = parcelRequire("9hlns");

var $hJgLA = parcelRequire("hJgLA");

var $03f7c = parcelRequire("03f7c");
const $cb337baea8f1bcdf$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $cb337baea8f1bcdf$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $cb337baea8f1bcdf$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $hJgLA.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $03f7c.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)(!(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$stylesOld.button, (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)(!(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$stylesOld.content, (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $cb337baea8f1bcdf$export$2e2bcd8739ae039 = $cb337baea8f1bcdf$var$ActionButton;

});



parcelRegister("jLXEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f415990ae4e7261e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1jfCH = parcelRequire("1jfCH");

var $afp1H = parcelRequire("afp1H");

var $6FZ6a = parcelRequire("6FZ6a");
const $f415990ae4e7261e$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jfCH))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).delete
        }),
        ...props
    });
var $f415990ae4e7261e$export$2e2bcd8739ae039 = $f415990ae4e7261e$var$DeleteAction;

});

parcelRegister("dVBHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74c68e5cf0852d5$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3QhJU = parcelRequire("3QhJU");

var $afp1H = parcelRequire("afp1H");

var $6FZ6a = parcelRequire("6FZ6a");
const $a74c68e5cf0852d5$var$EditAction = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QhJU))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).edit
        }),
        ...props
    });
var $a74c68e5cf0852d5$export$2e2bcd8739ae039 = $a74c68e5cf0852d5$var$EditAction;

});
parcelRegister("3QhJU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc3fd1be6624b0b$var$_react = $2cc3fd1be6624b0b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2cc3fd1be6624b0b$var$_edit = $2cc3fd1be6624b0b$var$_interopRequireDefault((parcelRequire("1Zr9M")));

var $2cc3fd1be6624b0b$var$_edit2 = $2cc3fd1be6624b0b$var$_interopRequireDefault((parcelRequire("1Nklh")));
function $2cc3fd1be6624b0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc3fd1be6624b0b$var$EditIcon = (props)=>/*#__PURE__*/ $2cc3fd1be6624b0b$var$_react.default.createElement($2cc3fd1be6624b0b$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $2cc3fd1be6624b0b$var$_edit2.default
    }, props));
$2cc3fd1be6624b0b$var$EditIcon.Name = 'EditIconMigration';
var $2cc3fd1be6624b0b$var$_default = module.exports.default = $2cc3fd1be6624b0b$var$EditIcon;

});


parcelRegister("cLh5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $47aa84bed0904f6b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $7rrdI = parcelRequire("7rrdI");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9oOnT = parcelRequire("9oOnT");

var $6FZ6a = parcelRequire("6FZ6a");
const $47aa84bed0904f6b$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).DownloadAction];
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $afp1H.messages).download_file : (0, $afp1H.messages).download;
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).download_description : (0, $afp1H.messages).download;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7rrdI))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $47aa84bed0904f6b$export$2e2bcd8739ae039 = $47aa84bed0904f6b$var$DownloadAction;

});

parcelRegister("9l03X", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd35d1180b7d8d14$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $hJgLA = parcelRequire("hJgLA");

var $fdQmL = parcelRequire("fdQmL");

var $itUVP = parcelRequire("itUVP");


const $fd35d1180b7d8d14$var$importIconMapper = {
    goal: ()=>(parcelRequire("44jk8")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("5IwBZ")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $fd35d1180b7d8d14$var$getIcon = (stackIconType)=>{
    const importFn = $fd35d1180b7d8d14$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $hJgLA.importIcon)(importFn);
};
const $fd35d1180b7d8d14$var$FollowAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $afp1H.messages).follow : (0, $afp1H.messages).unfollow;
    const projectMessage = value ? (0, $afp1H.messages).follow_project : (0, $afp1H.messages).unfollow_project;
    const goalMessage = value ? (0, $afp1H.messages).follow_goal : (0, $afp1H.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $afp1H.messages).follow_project_description : (0, $afp1H.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $afp1H.messages).follow_goal_description : (0, $afp1H.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $fd35d1180b7d8d14$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $7UHDa.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itUVP.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fdQmL.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $fd35d1180b7d8d14$export$2e2bcd8739ae039 = $fd35d1180b7d8d14$var$FollowAction;

});
parcelRegister("fdQmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36d75dc0f2bdcbc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kKODE = parcelRequire("kKODE");

var $g98dH = parcelRequire("g98dH");

var $8i8ID = parcelRequire("8i8ID");

var $7DSoa = parcelRequire("7DSoa");

var $1w3oA = parcelRequire("1w3oA");

var $6FZ6a = parcelRequire("6FZ6a");
const $a36d75dc0f2bdcbc$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const invoke = (0, $g98dH.default)();
    const reload = (0, $7DSoa.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleClick = (0, $gwFzn.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1w3oA.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8i8ID.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $a36d75dc0f2bdcbc$export$2e2bcd8739ae039 = $a36d75dc0f2bdcbc$var$ServerAction;

});
parcelRegister("1w3oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8421257f1cf5034c$export$2e2bcd8739ae039);
const $8421257f1cf5034c$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $8421257f1cf5034c$export$2e2bcd8739ae039 = $8421257f1cf5034c$var$createInvokeRequest;

});


parcelRegister("itUVP", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $3c347798ab285251$export$49248678d3914625);

var $afp1H = parcelRequire("afp1H");
const $3c347798ab285251$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $afp1H.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $afp1H.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $afp1H.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $afp1H.messages).unfollow_goal_error;
    return (0, $afp1H.messages).generic_error_message;
};

});

parcelRegister("44jk8", function(module, exports) {

let $2f66866c39f764db$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2f66866c39f764db$var$load("3wY4G").then(()=>parcelRequire('7EiCp'));

});

parcelRegister("5IwBZ", function(module, exports) {

let $429a5bd67710f04a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $429a5bd67710f04a$var$load("88r9N").then(()=>parcelRequire('lwRK9'));

});


parcelRegister("2vLbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c6ed50ac412c77$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bgJk4 = parcelRequire("bgJk4");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9oOnT = parcelRequire("9oOnT");

var $6FZ6a = parcelRequire("6FZ6a");
const $b8c6ed50ac412c77$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).PreviewAction];
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).preview_description : (0, $afp1H.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgJk4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $b8c6ed50ac412c77$export$2e2bcd8739ae039 = $b8c6ed50ac412c77$var$PreviewAction;

});

parcelRegister("apOlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91d440270dbacf8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $8Q3VW = parcelRequire("8Q3VW");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9oOnT = parcelRequire("9oOnT");

var $6FZ6a = parcelRequire("6FZ6a");
const $a91d440270dbacf8$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $gwFzn.useState)((0, $afp1H.messages).copy_url_to_clipboard);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $afp1H.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $a91d440270dbacf8$export$2e2bcd8739ae039 = $a91d440270dbacf8$var$CopyLinkAction;

});

parcelRegister("lVA2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1261186af9b2859$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $gdv5Z = parcelRequire("gdv5Z");
var $fVUfS = parcelRequire("fVUfS");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");
const $a1261186af9b2859$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $a1261186af9b2859$var$UnresolvedAction = ({ testId: testId = 'unresolved-action' })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $a1261186af9b2859$var$styles.message,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $a1261186af9b2859$var$styles.button,
        children: message
    }) : message;
};
var $a1261186af9b2859$export$2e2bcd8739ae039 = $a1261186af9b2859$var$UnresolvedAction;

});

parcelRegister("fl0WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $773427e96b58aed9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $g1LJt = parcelRequire("g1LJt");
const $773427e96b58aed9$var$AISummaryAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g1LJt.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $773427e96b58aed9$export$2e2bcd8739ae039 = $773427e96b58aed9$var$AISummaryAction;

});
parcelRegister("g1LJt", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $b80129153fa85400$export$8eed96bc6d982595);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $6KV13 = parcelRequire("6KV13");

var $f0eEY = parcelRequire("f0eEY");

var $blblm = parcelRequire("blblm");
const $b80129153fa85400$export$8eed96bc6d982595 = (props)=>{
    (0, $RUXAI.di)((0, $6KV13.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $6KV13.default)(url);
    (0, $gwFzn.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $blblm.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f0eEY.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("6KV13", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75904359bba5163$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $99WQy = parcelRequire("99WQy");
var $l6lJr = parcelRequire("l6lJr");

var $kKODE = parcelRequire("kKODE");

var $bIll3 = parcelRequire("bIll3");

var $lz9QA = parcelRequire("lz9QA");

var $8Bm55 = parcelRequire("8Bm55");

var $i8IAc = parcelRequire("i8IAc");
const $c75904359bba5163$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $c75904359bba5163$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $i8IAc.useAISummaryConfig)();
    const cardState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $99WQy.extractAri)(data);
    const dataUrl = data && (0, $l6lJr.extractLink)(data) || '';
    const onStart = (0, $gwFzn.useCallback)((id)=>{
        (0, $bIll3.startUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $gwFzn.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $bIll3.succeedUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $gwFzn.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $bIll3.failUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $8Bm55.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $c75904359bba5163$export$2e2bcd8739ae039 = $c75904359bba5163$var$useAISummaryAction;

});
parcelRegister("8Bm55", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $78ebc629fd62f804$export$becd8f2eba1bbd96);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $cbl6V = parcelRequire("cbl6V");

var $geR8p = parcelRequire("geR8p");
const $78ebc629fd62f804$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $gwFzn.useState)((0, $geR8p.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $geR8p.AISummariesStore).get(url)) (0, $geR8p.AISummariesStore).set(url, new (0, $cbl6V.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $geR8p.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $geR8p.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("cbl6V", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $b962d377d695bb74$export$73e4b807d5bd74b6);

var $9HkI0 = parcelRequire("9HkI0");

var $dDhJe = parcelRequire("dDhJe");

var $5Y0oB = parcelRequire("5Y0oB");

var $iPRQp = parcelRequire("iPRQp");

var $eDy2J = parcelRequire("eDy2J");
class $b962d377d695bb74$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $iPRQp.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $iPRQp.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
                return (0, $eDy2J.addPath)(baseUrl, path);
            }
            return (0, $eDy2J.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $5Y0oB.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $eDy2J.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}

});
parcelRegister("5Y0oB", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $ac7ab9469e66450d$export$e45226161c660403);

var $eDy2J = parcelRequire("eDy2J");
async function* $ac7ab9469e66450d$export$e45226161c660403(response) {
    const reader = (0, $eDy2J.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("eDy2J", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $80037b55255ba382$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $80037b55255ba382$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $80037b55255ba382$export$ff2962de2b2c930f);
const $80037b55255ba382$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $80037b55255ba382$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $80037b55255ba382$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $80037b55255ba382$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $80037b55255ba382$export$ff2962de2b2c930f = (product)=>{
    if ($80037b55255ba382$var$isJiraProduct(product)) return $80037b55255ba382$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("iPRQp", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $518e18325393707f$export$fcec967a4b7ebd84);
class $518e18325393707f$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $518e18325393707f$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("geR8p", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $ae7dbc37116e63f9$export$6979339b6d41707e);

var $aoOGA = parcelRequire("aoOGA");
const $ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE = 100;
const $ae7dbc37116e63f9$export$6979339b6d41707e = new (0, $aoOGA.LRUMap)($ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("i8IAc", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $524481383d1e73c2$export$4480af2c00aa7ebe);

var $gwFzn = parcelRequire("gwFzn");

var $eIleF = parcelRequire("eIleF");
const $524481383d1e73c2$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    return (0, $gwFzn.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("f0eEY", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $276cdae1a40ee2d2$export$75a19de44af58722);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3Mg7y = parcelRequire("3Mg7y");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $c8jtw = parcelRequire("c8jtw");

var $6FZ6a = parcelRequire("6FZ6a");

var $8NMxD = parcelRequire("8NMxD");
function $276cdae1a40ee2d2$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onCompleted = (0, $gwFzn.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $8NMxD.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $gwFzn.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $c8jtw.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("c8jtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6765627d6c82693a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $6765627d6c82693a$var$AiIcon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6Fdl.default), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $6765627d6c82693a$export$2e2bcd8739ae039 = $6765627d6c82693a$var$AiIcon;

});

parcelRegister("8NMxD", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $b750d65dda1a4c8d$export$82f46aa4e6535a45);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kbh18 = parcelRequire("kbh18");

var $4Oiym = parcelRequire("4Oiym");

var $6Px5Z = parcelRequire("6Px5Z");
const $b750d65dda1a4c8d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $kbh18.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Oiym.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6Px5Z.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("kbh18", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $681e47ebaeddecd0$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $681e47ebaeddecd0$export$cd2e891d7f87074d);

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");
const $681e47ebaeddecd0$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $681e47ebaeddecd0$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $afp1H.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5TXU5.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $afp1H.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $afp1H.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $afp1H.messages).ai_summary_error_generic,
                url: (0, $5TXU5.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("4Oiym", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd168d53d6086c0$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $kKODE = parcelRequire("kKODE");
const $9dd168d53d6086c0$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $9dd168d53d6086c0$export$2e2bcd8739ae039 = $9dd168d53d6086c0$var$AIEventErrorViewed;

});

parcelRegister("6Px5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $287ebec1fdd40e02$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");
const $287ebec1fdd40e02$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        href: (0, $5TXU5.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $287ebec1fdd40e02$export$2e2bcd8739ae039 = $287ebec1fdd40e02$var$AILearnMoreAnchor;

});



parcelRegister("blblm", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $8b66580330514e65$export$cfa1d3eed9a61059);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $gt9HV = parcelRequire("gt9HV");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $6FZ6a = parcelRequire("6FZ6a");
function $8b66580330514e65$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $gwFzn.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $gwFzn.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt9HV))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("loGLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $12d115b9ed847307$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $fxBfz = parcelRequire("fxBfz");

var $iXCQx = parcelRequire("iXCQx");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $3eMTN = parcelRequire("3eMTN");

var $6FZ6a = parcelRequire("6FZ6a");

var $5kt6m = parcelRequire("5kt6m");

var $dvupD = parcelRequire("dvupD");

const $12d115b9ed847307$var$AutomationModal = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("gA3AP")));
const $12d115b9ed847307$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5TXU5.ActionName).AutomationAction];
    const automationActionOnClick = (0, $gwFzn.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $dvupD.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $7UHDa.jsx)($12d115b9ed847307$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $afp1H.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $afp1H.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $afp1H.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $5kt6m.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $12d115b9ed847307$export$2e2bcd8739ae039 = $12d115b9ed847307$var$AutomationAction;

});
parcelRegister("3eMTN", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $bBN8z = parcelRequire("bBN8z");
const $a2cc1d898ee1f610$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a2cc1d898ee1f610$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext($a2cc1d898ee1f610$var$FALLBACK_API);
const $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $gwFzn.useState)(null);
    const api = (0, $gwFzn.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bBN8z.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $gwFzn.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $gwFzn.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8 = ()=>(0, $gwFzn.useContext)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c);

});
parcelRegister("bBN8z", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $67004d95b34ee986$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $67004d95b34ee986$var$styles = null;
const $67004d95b34ee986$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $gwFzn.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        onClick: onClick,
        className: (0, $35pXk.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("5kt6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $de78d57bbfdbed3e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $de78d57bbfdbed3e$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $de78d57bbfdbed3e$export$2e2bcd8739ae039 = $de78d57bbfdbed3e$var$AutomationManualTriggersGlyph;

});

parcelRegister("dvupD", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $916427ca86a2c806$export$93e707b363eaf5c8);

var $afp1H = parcelRequire("afp1H");
const $916427ca86a2c806$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $afp1H.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $afp1H.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("gA3AP", function(module, exports) {

let $c122cba4784f9594$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c122cba4784f9594$var$load("idfnC"),
    $c122cba4784f9594$var$load("cqZpg")
]).then(()=>parcelRequire('iWqmE'));

});


parcelRegister("9Gqdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c15e76cd694fe8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $3eMTN = parcelRequire("3eMTN");

var $6FZ6a = parcelRequire("6FZ6a");

var $1c7FN = parcelRequire("1c7FN");

const $c0c15e76cd694fe8$var$RelatedLinksModal = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("3no5r")));
const $c0c15e76cd694fe8$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onClick = (0, $gwFzn.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $7UHDa.jsx)($c0c15e76cd694fe8$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dh538.fg)('platform-linking-visual-refresh-v2') ? (0, $afp1H.messages).related_links_view_related_links : (0, $afp1H.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1c7FN.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $c0c15e76cd694fe8$export$2e2bcd8739ae039 = $c0c15e76cd694fe8$var$ViewRelatedLinksAction;

});
parcelRegister("1c7FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b0240da4db21c1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kevJM = parcelRequire("kevJM");

var $3Lj1C = parcelRequire("3Lj1C");

var $dh538 = parcelRequire("dh538");
const $c0b0240da4db21c1$var$rotateSvg = null; /**
                         * ChildIssuesIcon but 180 degrees rotated
                         */ 
const $c0b0240da4db21c1$var$RelatedLinksActionIcon = ()=>(0, $dh538.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Lj1C))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $c0b0240da4db21c1$export$2e2bcd8739ae039 = $c0b0240da4db21c1$var$RelatedLinksActionIcon;

});
parcelRegister("3Lj1C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::460873555b00dc694a7c27133071dd5e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bd484e223dfd8e8$var$_react = $2bd484e223dfd8e8$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2bd484e223dfd8e8$var$_childIssues = $2bd484e223dfd8e8$var$_interopRequireDefault((parcelRequire("19O12")));

var $2bd484e223dfd8e8$var$_childIssues2 = $2bd484e223dfd8e8$var$_interopRequireDefault((parcelRequire("fhXcL")));
function $2bd484e223dfd8e8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChildIssuesIcon.
 * This component is ChildIssuesIcon, with `UNSAFE_fallbackIcon` set to "ChildIssuesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bd484e223dfd8e8$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $2bd484e223dfd8e8$var$_react.default.createElement($2bd484e223dfd8e8$var$_childIssues.default, Object.assign({
        LEGACY_fallbackIcon: $2bd484e223dfd8e8$var$_childIssues2.default
    }, props));
$2bd484e223dfd8e8$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
var $2bd484e223dfd8e8$var$_default = module.exports.default = $2bd484e223dfd8e8$var$ChildIssuesIcon;

});


parcelRegister("3no5r", function(module, exports) {

let $275634380dcf78ef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $275634380dcf78ef$var$load("aoU9B").then(()=>parcelRequire('a6OFr'));

});





parcelRegister("2R1C4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab21bb04b9ccb77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $l7DP7 = parcelRequire("l7DP7");
const $1ab21bb04b9ccb77$var$BaseBlockStylesOld = null;
const $1ab21bb04b9ccb77$var$baseBlockStyles = null;
const $1ab21bb04b9ccb77$var$highlightRemoveStyles = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $1ab21bb04b9ccb77$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $1ab21bb04b9ccb77$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $1ab21bb04b9ccb77$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $1ab21bb04b9ccb77$var$Block = ({ children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style })=>{
    (0, $gwFzn.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $1ab21bb04b9ccb77$var$directionStyles[direction],
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $1ab21bb04b9ccb77$var$gapsStylesOld[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $1ab21bb04b9ccb77$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        children: (0, $l7DP7.renderChildren)(children, size)
    });
};
var $1ab21bb04b9ccb77$export$2e2bcd8739ae039 = $1ab21bb04b9ccb77$var$Block;

});



parcelRegister("1lLfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e07cec8e3b2cb3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");

var $l7DP7 = parcelRequire("l7DP7");
const $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES = 1;
const $8e07cec8e3b2cb3b$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $8e07cec8e3b2cb3b$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $8e07cec8e3b2cb3b$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $8e07cec8e3b2cb3b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES;
    if (maxLines < $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES;
    return maxLines;
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $8e07cec8e3b2cb3b$var$MetadataBlock = ({ maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES, status: status = (0, $5TXU5.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $l7DP7.renderElementItems)(primary);
    const secondaryElements = (0, $l7DP7.renderElementItems)(secondary);
    const { size: size = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const maxLinesTotal = $8e07cec8e3b2cb3b$var$getMaxLines(maxLines);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                align: (0, $5TXU5.SmartLinkAlignment).Left,
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $35pXk.default)([
                    $8e07cec8e3b2cb3b$var$truncateStyles[maxLinesTotal],
                    !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStylesOld[size],
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $35pXk.default)([
                    $8e07cec8e3b2cb3b$var$truncateStyles[maxLinesTotal],
                    !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStylesOld[size],
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $8e07cec8e3b2cb3b$export$2e2bcd8739ae039 = $8e07cec8e3b2cb3b$var$MetadataBlock;

});

parcelRegister("Y5kOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da662f4fc394f2e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $7ZZE6 = parcelRequire("7ZZE6");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $3da662f4fc394f2e$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $5TXU5.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7ZZE6.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $3da662f4fc394f2e$export$2e2bcd8739ae039 = $3da662f4fc394f2e$var$PreviewBlock;

});
parcelRegister("7ZZE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe31e0809d9677b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $bCoGW = parcelRequire("bCoGW");

var $2R1C4 = parcelRequire("2R1C4");
const $2fe31e0809d9677b$var$previewBlockStyleCommon = null;
const $2fe31e0809d9677b$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $2fe31e0809d9677b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $gwFzn.useState)(style ?? {});
    const updateStyles = (0, $gwFzn.useCallback)(()=>{
        if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $gwFzn.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $gwFzn.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $gwFzn.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $35pXk.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bCoGW.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $2fe31e0809d9677b$export$2e2bcd8739ae039 = $2fe31e0809d9677b$var$PreviewBlockResolvedView;

});


parcelRegister("8zS2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c86a1fbc149797$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $49WiA = parcelRequire("49WiA");

var $hJgLA = parcelRequire("hJgLA");

var $2R1C4 = parcelRequire("2R1C4");
const $60c86a1fbc149797$var$DEFAULT_MAX_LINES = 3;
const $60c86a1fbc149797$var$MAXIMUM_MAX_LINES = 6;
const $60c86a1fbc149797$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $60c86a1fbc149797$var$SnippetBlock = ({ maxLines: maxLines = $60c86a1fbc149797$var$DEFAULT_MAX_LINES, status: status = (0, $5TXU5.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $hJgLA.getMaxLines)(maxLines, $60c86a1fbc149797$var$DEFAULT_MAX_LINES, $60c86a1fbc149797$var$MAXIMUM_MAX_LINES, $60c86a1fbc149797$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $49WiA.default), {
            maxLines: snippetMaxLines,
            content: text
        })
    });
};
var $60c86a1fbc149797$export$2e2bcd8739ae039 = $60c86a1fbc149797$var$SnippetBlock;

});

parcelRegister("5znEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a4ce57d2ec07f2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $4gM1A = parcelRequire("4gM1A");

var $2gWqY = parcelRequire("2gWqY");

var $7d67T = parcelRequire("7d67T");

var $8LmiG = parcelRequire("8LmiG");

var $dxIYY = parcelRequire("dxIYY");

var $3HeI9 = parcelRequire("3HeI9");
const $86a4ce57d2ec07f2$var$actionStyles = null;
const $86a4ce57d2ec07f2$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return 0, $3HeI9.default;
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return 0, $dxIYY.default;
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return 0, $8LmiG.default;
    }
}; /**
    * Represents a TitleBlock, which is the foundation of Flexible UI.
    * This contains an icon, the link, and any associated metadata and actions in one block.
    * The TitleBlock will also render differently given the state of the smart link.
    * This can be found in the corresponding Resolving, Resolved and Errored views.
    * @public
    * @param {TitleBlockProps} TitleBlockProps
    * @see Block
    * @see TitleBlockResolvingViewNew
    * @see TitleBlockResolvedViewNew
    * @see TitleBlockErroredViewNew
    */ 
const $86a4ce57d2ec07f2$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: status = (0, $5TXU5.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, ...props })=>{
    if (!(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action')) {
        if (hideRetry && props.retry) delete props.retry;
    }
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $gwFzn.useState)(false);
    const onDropdownOpenChange = (0, $gwFzn.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gWqY.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $86a4ce57d2ec07f2$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $35pXk.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        ...(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? {
            hideRetry: hideRetry
        } : undefined,
        icon: icon,
        size: props.size,
        theme: theme
    });
};
var $86a4ce57d2ec07f2$export$2e2bcd8739ae039 = $86a4ce57d2ec07f2$var$TitleBlock;

});
parcelRegister("8LmiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f525c54e6e1b7b1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $lVA2Y = parcelRequire("lVA2Y");

var $2gWqY = parcelRequire("2gWqY");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $7f525c54e6e1b7b1$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    const context = (0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fUfR2.useFlexibleUiContext)() : {};
    const showRetry = (0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? !hideRetry && Boolean(context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]) : false;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gWqY.LinkIcon), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lVA2Y.default), {
                    testId: testId
                })
            }),
            !(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') && descriptor && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $7f525c54e6e1b7b1$export$2e2bcd8739ae039 = $7f525c54e6e1b7b1$var$TitleBlockErroredView;

});

parcelRegister("dxIYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1792527dfb9ef73$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $5TXU5 = parcelRequire("5TXU5");

var $2gWqY = parcelRequire("2gWqY");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");

var $l7DP7 = parcelRequire("l7DP7");
const $c1792527dfb9ef73$var$style = null; /**
                     * This renders a fully resolved TitleBlock.
                     * This should render when a Smart Link returns a valid response.
                     * @see TitleBlock
                     */ 
const $c1792527dfb9ef73$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $l7DP7.renderElementItems)(metadata);
    const subtitleElements = (0, $l7DP7.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gWqY.LinkIcon), {
                overrideIcon: icon,
                position: position,
                size: size
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1RvsP.default), {
                direction: (0, $5TXU5.SmartLinkDirection).Vertical,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $35pXk.default)([
                    "_zulp1b66"
                ]),
                children: [
                    title,
                    subtitleElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5TXU5.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $c1792527dfb9ef73$export$2e2bcd8739ae039 = $c1792527dfb9ef73$var$TitleBlockResolvedView;

});

parcelRegister("3HeI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $835b2d1437edfc5d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $hT8Jj = parcelRequire("hT8Jj");

var $hJgLA = parcelRequire("hJgLA");

var $2R1C4 = parcelRequire("2R1C4");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $835b2d1437edfc5d$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $835b2d1437edfc5d$export$2e2bcd8739ae039 = $835b2d1437edfc5d$var$TitleBlockResolvingView;

});


parcelRegister("eqpYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d73a30329f2f2d2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $8JQYF = parcelRequire("8JQYF");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $3d73a30329f2f2d2$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    if (status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8JQYF.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $3d73a30329f2f2d2$export$2e2bcd8739ae039 = $3d73a30329f2f2d2$var$AISummaryBlock;

});
parcelRegister("8JQYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6916bf0a97d23595$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $RUXAI = parcelRequire("RUXAI");

var $5TXU5 = parcelRequire("5TXU5");

var $6KV13 = parcelRequire("6KV13");

var $dYOF2 = parcelRequire("dYOF2");

var $6bBFP = parcelRequire("6bBFP");

var $2R1C4 = parcelRequire("2R1C4");

var $6iFTJ = parcelRequire("6iFTJ");
const $6916bf0a97d23595$var$styles = null;
const $6916bf0a97d23595$var$AISummaryBlockResolvedView = (props)=>{
    (0, $RUXAI.di)((0, $6KV13.default), (0, $dYOF2.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $gwFzn.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $35pXk.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6iFTJ.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6bBFP.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dYOF2.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $6916bf0a97d23595$export$2e2bcd8739ae039 = $6916bf0a97d23595$var$AISummaryBlockResolvedView;

});
parcelRegister("dYOF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9338d7fc86a81ff5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gUu2y = parcelRequire("gUu2y");

var $dh538 = parcelRequire("dh538");

var $gtWxL = parcelRequire("gtWxL");
const $9338d7fc86a81ff5$var$AISummaryCSSStyles = null;
const $9338d7fc86a81ff5$var$baseStyle = null; /**
                         * A component to render a response from AI in markdown text.
                         * @internal
                         * @param {AISummaryProps} AISummaryProps
                         */ 
const $9338d7fc86a81ff5$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gUu2y.default), {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $gtWxL.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $9338d7fc86a81ff5$export$2e2bcd8739ae039 = $9338d7fc86a81ff5$var$AISummary;

});
parcelRegister("gtWxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7359d17942e8a2$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");
const $bd7359d17942e8a2$var$listStyles = null;
const $bd7359d17942e8a2$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
        ...props,
        className: (0, $35pXk.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $bd7359d17942e8a2$export$2e2bcd8739ae039 = $bd7359d17942e8a2$var$UList;

});


parcelRegister("6bBFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30cfb4c0c886f9b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $c30cfb4c0c886f9b$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $gwFzn.useState)(0);
    const ref = (0, $gwFzn.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $gwFzn.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $c30cfb4c0c886f9b$export$2e2bcd8739ae039 = $c30cfb4c0c886f9b$export$6118ed0013927eb2;

});

parcelRegister("6iFTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9db9fca31c767$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $kKODE = parcelRequire("kKODE");
const $f7f9db9fca31c767$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f7f9db9fca31c767$export$2e2bcd8739ae039 = $f7f9db9fca31c767$var$AIEventSummaryViewed;

});



parcelRegister("MlN47", function(module, exports) {

$parcel$export(module.exports, "default", () => $38aa18aa215cb0bb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $8KTUJ = parcelRequire("8KTUJ");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $38aa18aa215cb0bb$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8KTUJ.default), {
        ...props,
        testId: testId
    });
};
var $38aa18aa215cb0bb$export$2e2bcd8739ae039 = $38aa18aa215cb0bb$var$AIFooterBlock;

});
parcelRegister("8KTUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f251934aee2626$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $2gWqY = parcelRequire("2gWqY");

var $2R1C4 = parcelRequire("2R1C4");

var $hs8S6 = parcelRequire("hs8S6");
const $92f251934aee2626$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2gWqY.Provider), {
                ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hs8S6.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $92f251934aee2626$export$2e2bcd8739ae039 = $92f251934aee2626$var$AIFooterBlockResolvedView;

});
parcelRegister("hs8S6", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $b7fbd07145f71993$export$175228cc2c92b3b6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $RUXAI = parcelRequire("RUXAI");

var $3Mg7y = parcelRequire("3Mg7y");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $3gadb = parcelRequire("3gadb");

var $afp1H = parcelRequire("afp1H");

var $6KV13 = parcelRequire("6KV13");

var $c8jtw = parcelRequire("c8jtw");

var $iGhkJ = parcelRequire("iGhkJ");
const $b7fbd07145f71993$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $RUXAI.di)((0, $6KV13.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $afp1H.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iGhkJ.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $c8jtw.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("iGhkJ", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $b60461a0f2dc3b3a$export$2957fc44b3d2481);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4vzBZ = parcelRequire("4vzBZ");

var $lC4PM = parcelRequire("lC4PM");
const $b60461a0f2dc3b3a$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lC4PM.default),
        ...props
    });

});
parcelRegister("lC4PM", function(module, exports) {

$parcel$export(module.exports, "default", () => $433ad242eadf8517$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $433ad242eadf8517$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $433ad242eadf8517$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $433ad242eadf8517$var$InfoIconGlyph
    });
var $433ad242eadf8517$export$2e2bcd8739ae039 = $433ad242eadf8517$var$InfoIcon;

});





parcelRegister("f0wtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $018f38f6aa2eb81b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $RUXAI = parcelRequire("RUXAI");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $jlQ9A = parcelRequire("jlQ9A");

var $1q2Dp = parcelRequire("1q2Dp");
const $018f38f6aa2eb81b$var$ignoreContainerPaddingStylesOld = null;
const $018f38f6aa2eb81b$var$ignoreContainerPaddingStyles = null;
const $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $018f38f6aa2eb81b$var$sort = (a, b)=>{
    let idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
}; /**
    * Get container padding based on smart link size
    * To replace container/index.tsx getPadding() with space token for primitives
    */ 
const $018f38f6aa2eb81b$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $018f38f6aa2eb81b$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $RUXAI.di)((0, $1q2Dp.ActionFooter));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $gwFzn.useState)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const onLoadingChange = (0, $gwFzn.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $018f38f6aa2eb81b$export$1af10e3728e3a644(ui?.size || (0, $5TXU5.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $gwFzn.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $gwFzn.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $gwFzn.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($018f38f6aa2eb81b$var$sort);
        return arr.map((name)=>{
            const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $7UHDa.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1q2Dp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $018f38f6aa2eb81b$export$2e2bcd8739ae039 = $018f38f6aa2eb81b$var$ActionBlock;

});
parcelRegister("1q2Dp", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $dfe1275874cc34dc$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $bSmaw = parcelRequire("bSmaw");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $6bBFP = parcelRequire("6bBFP");
const $dfe1275874cc34dc$var$containerStyles = null;
const $dfe1275874cc34dc$var$errorStyles = null;
const $dfe1275874cc34dc$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $dfe1275874cc34dc$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSmaw))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
            });
        default:
            return null;
    }
};
const $dfe1275874cc34dc$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $dh538.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $dfe1275874cc34dc$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6bBFP.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $dfe1275874cc34dc$var$styles.errorContentStyles,
                children: [
                    message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $dfe1275874cc34dc$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $35pXk.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6bBFP.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $dfe1275874cc34dc$var$styles.errorContentStyles,
                children: [
                    message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $dfe1275874cc34dc$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});





//# sourceMappingURL=modal.d02415b5.js.map
